import firebase from 'firebase/compat/app';
import React, { useState, useEffect, useCallback, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import moment from "moment-timezone";
// import DatePicker from "react-datepicker";
import EnhancedDateRangePicker from "../../components/common/EnhancedDateRangePicker";
import { startOfMonth, endOfMonth, formatISO, startOfDay, endOfDay, sub } from "date-fns";
import { Link } from "react-router-dom";

import PageTitle from "../../components/common/PageTitle";
import Pagination from "../../components/common/Pagination";
import ActivityIndicator from "../../components/common/ActivityIndicator";
import SmallStats from "../../components/common/SmallStats";
import AdjustBalanceModal from "../../components/common/AdjustBalanceModal";
import DisputeQuickView from "../Citations/DisputeQuickView";
import RecommendedAction from "./RecommendedAction";
import DisputeAnalysisContainer from "../../components/DisputeAnalysis/DisputeAnalysisContainer";

import "react-datepicker/dist/react-datepicker.css";

import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  ButtonGroup,
  FormGroup,
  FormInput,
  FormTextarea,
  Form,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Nav,
  NavItem,
  NavLink,
  ListGroup,
  ListGroupItem,
  Alert,
  Progress,
  FormSelect
} from "shards-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSort,
  faSortUp,
  faSortDown,
  faEllipsisH,
  faTimes,
  faEye,
  faCheck,
  faEdit,
  faPlus,
  faSearch,
  faFileInvoiceDollar,
  faUserTie,
  faUserCircle,
  faChartPie,
  faQuestionCircle,
  faThumbsUp,
  faThumbsDown,
  faCalendar,
  faCheckCircle,
  faTimesCircle,
  faBell,
  faExclamationTriangle,
  faChartLine,
  faExclamation,
  faEnvelope,
  faPhone,
  faBrain,
  faCaretDown,
  faFilter,
  faExternalLinkAlt,
  faSlidersH,
  faArrowUp,
  faArrowDown,
  faRobot,
  faCheckDouble,
  faUsers,
  faSearchDollar,
  faClipboardCheck,
  faClock,
  faPercent,
  faLightbulb,
  faPlusCircle,
  faCreditCard,
  faInfoCircle
} from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import RowActions from '../../components/common/RowActions';

/* 
const datePickerStyles = `
  .react-datepicker {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    border-radius: 6px;
    border: 1px solid #eaedf3;
    box-shadow: 0 8px 24px rgba(149, 157, 165, 0.2);
    z-index: 9999;
  }
  .react-datepicker__header {
    background-color: #fff;
    border-bottom: 1px solid #eaedf3;
    padding-top: 10px;
  }
  .react-datepicker__current-month {
    font-weight: 600;
    font-size: 14px;
    padding-bottom: 6px;
    color: #1b1b1b;
  }
  .react-datepicker__day-name {
    color: #818ea3;
    font-weight: 500;
    font-size: 12px;
    margin-top: 4px;
  }
  .react-datepicker__day {
    color: #495057;
    font-weight: 400;
    font-size: 13px;
    transition: background-color 0.2s, color 0.2s;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    line-height: 36px;
    margin: 2px;
  }
  .react-datepicker__day:hover {
    background-color: #f5f6f8;
    border-radius: 50%;
  }
  .react-datepicker__day--selected,
  .react-datepicker__day--in-range,
  .react-datepicker__day--in-selecting-range {
    background-color: #21AA73;
    color: white;
    font-weight: 500;
  }
  .react-datepicker__day--keyboard-selected {
    background-color: rgba(33, 170, 115, 0.2);
    border-radius: 50%;
    color: #21AA73;
  }
  .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {
    background-color: rgba(33, 170, 115, 0.5);
  }
  .react-datepicker__day--in-range {
    border-radius: 0;
    background-color: rgba(33, 170, 115, 0.7);
  }
  
  .react-datepicker__day--range-start,
  .react-datepicker__day--range-end,
  .react-datepicker__day--selecting-range-start,
  .react-datepicker__day--selecting-range-end {
    background-color: #21AA73;
    border-radius: 50%;
  }
  .react-datepicker__navigation {
    top: 10px;
  }
  .react-datepicker__navigation-icon::before {
    border-color: #818ea3;
    border-width: 2px 2px 0 0;
  }
  .react-datepicker__navigation:hover *::before {
    border-color: #21AA73;
  }
`;
*/

const DisputeCenter = (props) => {
  const { 
    user, 
    clients, 
    disputes: propDisputes, 
    loading,
    getClients, 
    getDisputes,
    acceptDispute,
    rejectDispute,
    adjustDispute
  } = props;
  
  // Add initial debug logging
  console.log("User:", user);
  console.log("All clients:", clients);
  console.log("Client ID check:", user?.client);
  
  // Check for currentClient with available inputs
  console.log("Checking for currentClient with these inputs:");
  console.log("- User object:", user);
  console.log("- Client ID from user:", user?.client);
  console.log("- Available clients:", clients?.length > 0 ? `${clients.length} clients loaded` : "No clients loaded", clients);
  
  // Debug the enable_dispute_assistant flag
  console.log("Enable dispute assistant flag value:", user?.enable_dispute_assistant);
  console.log("Flag data type:", typeof user?.enable_dispute_assistant);
  
  // Super users should always see the feature, and clients need the enable_dispute_assistant flag
  console.log("Enable dispute assistant RAW value:", user?.enable_dispute_assistant);
  
  // Add development override for testing (remove in production)
  const DEV_OVERRIDE_ENABLED = process.env.NODE_ENV === 'development';
  
  // More robust feature flag check using the helper function
  const isDisputeAssistantEnabled = 
    DEV_OVERRIDE_ENABLED ||
    user?.type === 'super' || 
    user?.type === 'client_admin' ||
    user?.type === 'client' ||
    (currentClient && isFeatureFlagEnabled(currentClient.enable_dispute_assistant)) ||
    isFeatureFlagEnabled(user?.enable_dispute_assistant) ||
    (currentClient && currentClient.status === 'active' && currentClient.tier === 'premium');
  
  // Log why feature is disabled or enabled
  if (!isDisputeAssistantEnabled) {
    console.log("Dispute Assistant disabled because:", 
      user?.type !== 'super' && user?.type !== 'client_admin' && user?.type !== 'client' ? 
        "User doesn't have required permissions" : "Feature flag check failed",
      "User type:", user?.type,
      "Current client:", currentClient,
      "Client feature flag:", currentClient?.enable_dispute_assistant,
      "User feature flag:", user?.enable_dispute_assistant,
      "Client status:", currentClient?.status,
      "Client tier:", currentClient?.tier,
      "DEV_OVERRIDE:", DEV_OVERRIDE_ENABLED
    );
  } else {
    console.log("✅ Dispute Assistant is ENABLED because:", 
      DEV_OVERRIDE_ENABLED ? "DEV_OVERRIDE is active" :
      user?.type === 'super' ? "User is a super admin" : 
      user?.type === 'client_admin' ? "User is a client admin" :
      user?.type === 'client' ? "User is a client" :
      (currentClient && isFeatureFlagEnabled(currentClient.enable_dispute_assistant)) ? "Client has feature flag enabled" :
      isFeatureFlagEnabled(user?.enable_dispute_assistant) ? "User has feature flag enabled" :
      (currentClient && currentClient.status === 'active' && currentClient.tier === 'premium') ? "Client is active premium tier" :
      "Unknown reason"
    );
  }
  
  // Replace dummy functions with actual Gemini API calls
  const getScoreForEmail = (email) => {
    if (!email) return 50; // Default score if no email
    
    try {
      // In a real implementation, this would call the Gemini API
      // to analyze the email and return a trust score
      return 50; // Default return until Gemini API is implemented
    } catch (error) {
      console.error("Error getting trust score:", error);
      return 50; // Default fallback score
    }
  };
  
  const getTrustScoreColor = (score) => {
    if (score >= 80) return "#21AA73"; // green
    if (score >= 60) return "#F9A43F"; // orange
    return "#C81712"; // red
  };
  
  const getTrustText = (score) => {
    if (score >= 80) return "High Trust";
    if (score >= 60) return "Medium Trust";
    return "Low Trust";
  };
  
  const [disputes, setDisputes] = useState([]);
  const [search, setSearch] = useState('');
  const [sortBy, setSortBy] = useState('dateDesc');
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(() => {
    // Try to load saved page size from localStorage
    const savedPageSize = localStorage.getItem('disputes_page_size');
    return savedPageSize ? parseInt(savedPageSize, 10) : 25;
  });
  const [client, setClient] = useState(() => {
    // For non-super users, default to their client ID
    // For super users, default to 'all'
    return user && user.type !== 'super' && user.client ? user.client : 'all';
  });
  const [startDate, setStartDate] = useState(() => {
    // Check if there's a saved date range in localStorage
    const savedStartDate = localStorage.getItem('enforcePlus_startDate');
    return savedStartDate ? new Date(savedStartDate) : startOfMonth(new Date());
  });
  const [endDate, setEndDate] = useState(() => {
    // Check if there's a saved date range in localStorage
    const savedEndDate = localStorage.getItem('enforcePlus_endDate');
    return savedEndDate ? new Date(savedEndDate) : endOfMonth(new Date());
  });
  const [showAdjustModal, setShowAdjustModal] = useState(false);
  const [showQuickViewModal, setShowQuickViewModal] = useState(false);
  const [showAiInsightsModal, setShowAiInsightsModal] = useState(false);
  const [activeAiTab, setActiveAiTab] = useState("recommended");
  const [selectedDispute, setSelectedDispute] = useState(null);
  const [aiRatings, setAiRatings] = useState({});
  const [showStatsModal, setShowStatsModal] = useState(false);
  const [confidenceThreshold, setConfidenceThreshold] = useState(85);
  const [showConfidenceDropdown, setShowConfidenceDropdown] = useState(false);
  const [showAutoResolutionModal, setShowAutoResolutionModal] = useState(false);
  const [autoResolutionEnabled, setAutoResolutionEnabled] = useState(false);
  const [analyzing, setAnalyzing] = useState(false);
  const [disputePatterns, setDisputePatterns] = useState(null);
  const [showAnalysisResultsModal, setShowAnalysisResultsModal] = useState(false);
  const [activeAutoResolutionTab, setActiveAutoResolutionTab] = useState("settings");
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const [currentFeedbackDispute, setCurrentFeedbackDispute] = useState(null);
  const [feedbackText, setFeedbackText] = useState('');
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
  const confidenceDropdownRef = useRef(null);
  const applyButtonRef = useRef(null);
  
  // Metrics
  const [metrics, setMetrics] = useState({
    openDisputes: 0,
    adjustedUnpaid: 0,
    avgResolutionTime: 0,
    acceptedPercentage: 0,
    rejectedPercentage: 0,
    adjustedPercentage: 0
  });
  const [acknowledgedSuggestions, setAcknowledgedSuggestions] = useState([]);
  // Create state for team analysis data (to replace dummyAiData references)
  const [teamAnalysisData, setTeamAnalysisData] = useState({
    officers: [
      // This will be populated from real data in the future
    ],
    insights: [],
    recommendations: []
  });

  // Create state for dispute analysis data
  const [disputeAnalysisData, setDisputeAnalysisData] = useState({
    commonReasons: [],
    reasonsLastMonth: 0,
    percentageIncrease: 0,
    averageReasoningQuality: "",
    averageEvidenceQuality: "",
    detectedSentiment: ""
  });

  // Create state for approach suggestions
  const [approachSuggestions, setApproachSuggestions] = useState([]);
  
  // Add new state variables for client selection
  const [showClientSelectorModal, setShowClientSelectorModal] = useState(false);
  const [selectedClientForAnalysis, setSelectedClientForAnalysis] = useState(null);
  
  // Add client loading state
  const [clientsLoading, setClientsLoading] = useState(true);
  const [localClients, setLocalClients] = useState([]);
  const [currentClient, setCurrentClient] = useState(null);
  
  // Add these new state variables
  const [showAnalysisModal, setShowAnalysisModal] = useState(false);
  const [selectedForAnalysis, setSelectedForAnalysis] = useState(null);
  
  // Fetch disputes, clients, etc on mount
  useEffect(() => {
    console.log("DisputeCenter mounted, fetching data...");
    document.title = "Dispute Assistant";
    
    // For super users, always load all clients
    if (user && user.type === 'super') {
      console.log("Super user detected, loading all clients");
      getClients();
    }
    
    // Get disputes - this should handle the case when client isn't loaded yet
    loadDisputes();
    // Apply initializers
    initializeDisputeStates();
  }, []);
  
  // When disputes or filter changes, update UI
  useEffect(() => {
    console.log(`Disputes updated from props: ${propDisputes?.length || 0} disputes`);
    
    // Store disputes in local state
    if (propDisputes && Array.isArray(propDisputes)) {
      setDisputes(propDisputes);
      
      // Calculate metrics
      calculateDisputeMetrics(propDisputes);
      
      // Log client filtering for client users
      if (user && user.type !== 'super' && user.client) {
        const clientDisputes = propDisputes.filter(d => d.client === user.client);
        console.log(`Client user (${user.client}): ${propDisputes.length} total disputes, ${clientDisputes.length} for this client`);
      }
    } else {
      console.log("No disputes received from props or invalid format");
      setDisputes([]);
    }
  }, [propDisputes, user]);
  
  // Memoize the loadDisputes function to ensure it doesn't change on every render
  const loadDisputes = useCallback(() => {
    console.log("Loading disputes...");
    
    // Determine client ID parameter based on user type
    let clientId = null;
    
    if (user && user.type !== 'super' && user.client) {
      // For non-super users, use their client ID
      clientId = user.client;
      console.log("Client user - using client ID:", clientId);
    } else if (user && user.type === 'super' && client && client !== 'all') {
      // For super users with selected client
      clientId = client;
      console.log("Super user - using selected client:", clientId);
    } else {
      console.log("Super user - loading all clients' disputes");
    }
    
    // Make sure dates are valid
    const validStartDate = startDate || new Date();
    const validEndDate = endDate || new Date();
    
    console.log("Fetching disputes with params:", {
      clientId,
      startDate: formatISO(validStartDate),
      endDate: formatISO(validEndDate),
    });
    
    // Call the getDisputes action from props
    getDisputes(
      null, // location ID - null means all locations
      clientId,
      formatISO(validStartDate),
      formatISO(validEndDate),
      null // user ID - null means all users
    );
  }, [user, client, startDate, endDate, getDisputes]);
  
  // Refresh disputes when date range or client changes
  useEffect(() => {
    console.log("Date range or client filter changed, reloading disputes");
    loadDisputes();
  }, [startDate, endDate, client, loadDisputes]);
  
  // Fetch clients - separate from other data loading
  useEffect(() => {
    const loadClients = async () => {
      setClientsLoading(true);
      
      try {
        console.log("Fetching clients...");
        const fetchedClients = await getClients();
        console.log("Fetched clients:", fetchedClients);
        setLocalClients(fetchedClients);
        console.log("Local clients state set:", localClients);
      } catch (error) {
        console.error("Error loading clients:", error);
      } finally {
        setClientsLoading(false);
      }
    };
    
    if (user && user.type === 'super') {
      loadClients();
    } else {
      setClientsLoading(false);
    }
  }, [user, getClients]);

  // Ensure localClients updates when props.clients changes
  useEffect(() => {
    console.log("Props clients changed:", clients);
    if (clients) {
      setLocalClients(clients);
      console.log("Updated localClients from props:", localClients);
    }
  }, [clients]);
  
  // Find currentClient based on user.client when localClients or user changes
  useEffect(() => {
    if (user && user.client && localClients && localClients.length > 0) {
      const foundClient = localClients.find(c => c.id === user.client);
      
      if (foundClient) {
        console.log("✅ Found currentClient based on user.client:", foundClient);
        // Log all properties on the client to help debug
        console.log("Client properties:", Object.keys(foundClient));
        console.log("Client enable_dispute_assistant property:", foundClient.enable_dispute_assistant);
        
        // Check for alternative property names (case insensitive)
        const clientProperties = Object.keys(foundClient);
        const assistantFlagProperty = clientProperties.find(
          key => key.toLowerCase() === 'enable_dispute_assistant' || 
                 key.toLowerCase() === 'enabledisputeassistant' || 
                 key.toLowerCase() === 'dispute_assistant_enabled'
        );
        
        if (assistantFlagProperty && assistantFlagProperty !== 'enable_dispute_assistant') {
          console.log(`Found alternative property name: ${assistantFlagProperty} with value:`, foundClient[assistantFlagProperty]);
          // Create a new object with the standard property name
          const clientWithStandardProp = {
            ...foundClient,
            enable_dispute_assistant: foundClient[assistantFlagProperty]
          };
          setCurrentClient(clientWithStandardProp);
        } else {
          setCurrentClient(foundClient);
        }
      } else {
        console.log("❌ Could not find client with ID", user.client, "in localClients");
        console.log("Available client IDs:", localClients.map(c => c.id));
        setCurrentClient(null);
      }
    } else {
      console.log("Not setting currentClient:", {
        hasUser: !!user,
        userClientId: user?.client,
        hasLocalClients: !!localClients,
        localClientsLength: localClients?.length || 0
      });
      
      if (currentClient !== null) {
        setCurrentClient(null);
      }
    }
  }, [user, localClients, currentClient]);
  
  // Helper function to check if feature flag is enabled (handles various formats)
  const isFeatureFlagEnabled = (flag) => {
    if (flag === undefined || flag === null) return false;
    
    // Check for boolean true
    if (flag === true) return true;
    
    // Check for string 'true'
    if (typeof flag === 'string' && flag.toLowerCase() === 'true') return true;
    
    // Check for number 1
    if (flag === 1 || flag === '1') return true;
    
    // Check for string 'yes'
    if (typeof flag === 'string' && flag.toLowerCase() === 'yes') return true;
    
    // Check for string 'on'
    if (typeof flag === 'string' && flag.toLowerCase() === 'on') return true;
    
    // If it's a non-empty string that's not '0' or 'false'
    if (typeof flag === 'string' && flag !== '' && flag !== '0' && flag.toLowerCase() !== 'false') return true;
    
    // If it's a non-zero number
    if (typeof flag === 'number' && flag !== 0) return true;
    
    return false;
  };
  
  // Debug client and feature flag status
  console.log("Current client state:", currentClient);
  console.log("Enable dispute assistant flag value:", currentClient?.enable_dispute_assistant);
  
  // Set up app state on initial mount
  useEffect(() => {
    document.title = "Dispute Assistant";
    // Initialize UI state
    initializeDisputeStates();
  }, []);
  
  // Load disputes when date range or client changes
  useEffect(() => {
    loadDisputes();
  }, [loadDisputes]);
  
  // When disputes data changes from props, update local state and calculate metrics
  useEffect(() => {
    if (propDisputes && propDisputes.length > 0) {
      console.log("Disputes received:", propDisputes.length);
      
      // Debug the first dispute to see its structure
      if (propDisputes[0]) {
        console.log("First dispute structure:", propDisputes[0]);
      }
      
      setDisputes(propDisputes);
      
      // Calculate metrics
      calculateDisputeMetrics(propDisputes);
    } else {
      console.log("No disputes received from props");
      
      // Clear disputes if none received from props
      setDisputes([]);
      calculateDisputeMetrics([]);
    }
  }, [propDisputes]);
  
  // Calculate metrics from dispute data
  const calculateDisputeMetrics = (disputeData) => {
    // Count of open disputes
    const openDisputes = disputeData.filter(d => d.dispute?.status === 'open').length;
    
    // Count of adjusted but unpaid disputes
    const adjustedUnpaid = disputeData.filter(d => 
      d.dispute?.status === 'adjusted' && d.status !== 'paid'
    ).length;
    
    // Calculate resolution time (for disputes that have been resolved)
    const resolvedDisputes = disputeData.filter(d => 
      d.dispute?.status !== 'open' && 
      d.disputed_on && 
      (d.dispute?.accepted_on || d.dispute?.rejected_on || d.dispute?.adjusted_on)
    );
    
    let totalResolutionTimeHours = 0;
    
    resolvedDisputes.forEach(d => {
      const disputedDate = moment(d.disputed_on);
      const resolvedDate = moment(
        d.dispute?.accepted_on || 
        d.dispute?.rejected_on || 
        d.dispute?.adjusted_on
      );
      
      const diffHours = resolvedDate.diff(disputedDate, 'hours');
      totalResolutionTimeHours += diffHours;
    });
    
    const avgResolutionTime = resolvedDisputes.length > 0 
      ? (totalResolutionTimeHours / resolvedDisputes.length).toFixed(1) 
      : 0;
    
    // Calculate percentages by resolution type
    const totalResolvedCount = disputeData.filter(d => d.dispute?.status !== undefined).length;
    
    if (totalResolvedCount > 0) {
      const acceptedCount = disputeData.filter(d => d.dispute?.status === 'accepted').length;
      const rejectedCount = disputeData.filter(d => d.dispute?.status === 'rejected').length;
      const adjustedCount = disputeData.filter(d => d.dispute?.status === 'adjusted').length;
      
      const acceptedPercentage = Math.round((acceptedCount / totalResolvedCount) * 100);
      const rejectedPercentage = Math.round((rejectedCount / totalResolvedCount) * 100);
      const adjustedPercentage = Math.round((adjustedCount / totalResolvedCount) * 100);
      
      setMetrics({
        openDisputes,
        adjustedUnpaid,
        avgResolutionTime,
        acceptedPercentage,
        rejectedPercentage,
        adjustedPercentage
      });
    }
  };
  
  // Function to open client selector modal
  const openClientSelector = () => {
    // For non-super users, we don't need to show the client selector
    // We can directly use their client ID
    if (user && user.type !== 'super' && user.client) {
      console.log("Client user - directly analyzing their client data:", user.client);
      // Just run the analysis with their client ID
      runHistoricalAnalysis(user.client);
    } else {
      // For super users, show the client selector modal
      console.log("Super user - showing client selector");
      setSelectedClientForAnalysis(null);
      setShowClientSelectorModal(true);
    }
  };
  
  // Function to run historical analysis with selected client
  const runHistoricalAnalysisForClient = () => {
    setShowClientSelectorModal(false);
    runHistoricalAnalysis(selectedClientForAnalysis);
  };
  
  // Function to run historical dispute analysis
  const runHistoricalAnalysis = async (clientId = null) => {
    try {
      // Show loading indicator
      setAnalyzing(true);
      
      // For non-super users, enforce their client ID
      let finalClientId = clientId;
      if (user && user.type !== 'super' && user.client) {
        finalClientId = user.client;
        console.log("Enforcing client ID for regular user:", finalClientId);
      }
      
      console.log("Calling analyzeHistoricalDisputes Firebase function...");
      
      // Add a timeout to prevent hanging - increase timeout for larger datasets
      const analyzeHistoricalDisputesFunction = firebase.functions().httpsCallable('analyzeHistoricalDisputes');
      
      // Create a longer timeout for better success chance
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => reject(new Error("Request timed out after 45 seconds")), 45000);
      });
      
      // Try up to 2 times with different configurations if needed
      let result;
      let attempts = 0;
      const maxAttempts = 2;
      
      // Prepare alternative query strategies to try
      const queryStrategies = [
        // Strategy 1: Using tickets collectionGroup with disputed_on field check
        () => ({
          batchSize: 5,
          limit: 15,
          allClients: !finalClientId,
          clientId: finalClientId,
          userType: user?.type || 'client',
          analysisType: 'dispute',
          queryMethod: 'direct',
          version: 3,
          useCollectionGroup: true,
          collectionGroup: 'tickets',
          whereConditions: [
            ['disputed_on', '!=', null],
          ],
          forceSimpleQueries: false,
          directQueryOnly: false,
          skipCollectionGroupQueries: false,
          isImpersonated: props.impersonated || false
        }),
        // Strategy 2: Alternative approach with different batch settings
        () => ({
          batchSize: 3,
          limit: 10,
          allClients: !finalClientId,
          clientId: finalClientId,
          userType: user?.type || 'client',
          analysisType: 'dispute',
          queryMethod: 'direct',
          version: 3,
          useCollectionGroup: true,
          collectionGroup: 'tickets',
          whereConditions: [
            ['disputed_on', '!=', null],
          ],
          forceSimpleQueries: true,
          directQueryOnly: false,
          skipCollectionGroupQueries: false,
          isImpersonated: props.impersonated || false
        })
      ];
      
      while (attempts < maxAttempts) {
        attempts++;
        console.log(`Attempt ${attempts} of ${maxAttempts}...`);
        
        try {
          // Use different strategy based on attempt number
          const strategy = queryStrategies[attempts - 1] || queryStrategies[0];
          
          // Race the real function call against the timeout
          result = await Promise.race([
            analyzeHistoricalDisputesFunction(strategy()),
            timeoutPromise
          ]);
          
          // If we got a result, break out of retry loop
          if (result && result.data) {
            console.log("Function response received:", result.data);
            break;
          }
        } catch (retryError) {
          console.error(`Attempt ${attempts} failed:`, retryError);
          
          // If this was the last attempt, rethrow
          if (attempts >= maxAttempts) {
            throw retryError;
          }
          
          // Wait before retry
          await new Promise(resolve => setTimeout(resolve, 1000));
        }
      }
      
      // Rest of the function remains the same
      if (result.data && result.data.success) {
        if (result.data.metaAnalysis) {
          console.log("Valid metaAnalysis data received:", result.data.metaAnalysis);
          
          // Store meta-analysis in state to display in UI
          setDisputePatterns(result.data.metaAnalysis);
          
          // Show the results modal
          setShowAnalysisResultsModal(true);
          
          // Successful operation notification
          alert(`Successfully analyzed ${result.data.processedDisputes} historical disputes in ${result.data.batches} batches.`);
        } else if (result.data.message) {
          // Function ran but no analysis was possible
          console.log("Function message:", result.data.message);
          alert(result.data.message);
          
          if (result.data.basicStats) {
            console.log("Basic stats received:", result.data.basicStats);
            
            // If we got basic stats but no full analysis, create a simplified result
            const simplifiedAnalysis = {
              scamPatterns: [],
              legitimatePatterns: [],
              languageAnalysis: {
                fraudulentPhrases: [],
                legitimatePhrases: []
              },
              insights: [
                `Found ${result.data.processedDisputes} historical disputes`,
                `Accepted: ${result.data.basicStats.resolutionStats?.accepted || 0} disputes`,
                `Rejected: ${result.data.basicStats.resolutionStats?.rejected || 0} disputes`,
                `Adjusted: ${result.data.basicStats.resolutionStats?.adjusted || 0} disputes`,
                "Not enough data for full pattern analysis"
              ]
            };
            
            setDisputePatterns(simplifiedAnalysis);
            setShowAnalysisResultsModal(true);
          }
        }
      } else {
        console.error("Function returned success:false or invalid format:", result.data);
        throw new Error("Invalid response format from analysis function");
      }
    } catch (error) {
      console.error("Error analyzing historical disputes:", error);
      
      // Extract meaningful error information with better parsing
      let errorMessage = "Analysis failed: ";
      let errorDetails = "";
      
      // Create simplified insights to provide some value even on failure
      const createFallbackInsights = () => {
        // Create basic insights from general best practices
        return {
          scamPatterns: [
            {
              pattern: "Common Dispute Patterns",
              indicators: [
                "Look for disputes with similar language/wording",
                "Check for multiple disputes from same email domain",
                "Note disputes submitted in rapid succession"
              ],
              frequency: "~20%",
              recommendedResponse: "Review closely and check for connections between similar disputes"
            }
          ],
          legitimatePatterns: [
            {
              pattern: "Valid Dispute Indicators",
              indicators: [
                "Clear timestamps on evidence",
                "Consistent details across submissions",
                "Prompt submission after alleged violation"
              ],
              frequency: "~60%",
              recommendedResponse: "Verify evidence authenticity against system records"
            }
          ],
          languageAnalysis: {
            fraudulentPhrases: [],
            legitimatePhrases: []
          },
          insights: [
            "Note: These are general insights as full analysis couldn't be completed",
            "Consider reviewing recent disputes manually to identify patterns",
            "Common legitimate disputes often include clear evidence timestamps",
            "Potential fraudulent disputes often contain vague timestamps or locations",
            "The database query failed, but these insights may still be helpful"
          ]
        };
      };
      
      if (error.message && error.message.includes("collectionGroup is not a function")) {
        errorMessage = "Database query structure error";
        errorDetails = "The system encountered a technical issue with the database query. We've provided general insights instead.";
        
        // Show simplified alternate insights instead of full error
        setDisputePatterns(createFallbackInsights());
        setShowAnalysisResultsModal(true);
        
        // Show specific error alert with more helpful information
        alert(`${errorMessage}\n\n${errorDetails}\n\nWe've provided some general insights that may still be helpful.`);
        
        // Exit early since we're showing fallback data
        setAnalyzing(false);
        return;
      } else if (error.message && error.message.includes("permission_denied")) {
        errorMessage = "Permission denied";
        errorDetails = "You don't have sufficient permissions to access this data. Please contact support.";
      } else if (error.message && error.message.includes("timeout")) {
        errorMessage = "Request timeout";
        errorDetails = "The analysis is taking too long to complete. Try analyzing a smaller dataset or try again later.";
      } else if (error.message) {
        errorMessage = "Error: ";
        errorDetails = error.message;
      } else if (error.code) {
        errorMessage = "Error code: ";
        errorDetails = error.code;
      } else {
        errorMessage = "Unknown error";
        errorDetails = "An unexpected error occurred. Please try again or contact support.";
      }
      
      // Show specific error alert with more helpful information
      alert(`${errorMessage}\n\n${errorDetails}`);
      
      // Create analysis with more useful error information
      const errorAnalysis = {
        scamPatterns: [],
        legitimatePatterns: [],
        languageAnalysis: {
          fraudulentPhrases: [],
          legitimatePhrases: []
        },
        insights: [
          `Error: ${errorMessage}`,
          errorDetails,
          "Please check the browser console for more information",
          "If this issue persists, contact support with error details"
        ]
      };
      
      // Show error info in the modal
      setDisputePatterns(errorAnalysis);
      setShowAnalysisResultsModal(true);
    } finally {
      setAnalyzing(false);
    }
  };
  
  // Generate mock analysis data for demonstration/development
  const generateMockAnalysisData = () => {
    return {
      // Mock data structure
    };
  };
  
  // Function to initialize dispute states
  const initializeDisputeStates = () => {
    setAiRatings({});
    setPage(1);
  };
  
  // Function to filter disputes based on search and other criteria
  const filterDisputes = () => {
    if (!disputes || disputes.length === 0) {
      console.log("No disputes to filter");
      return [];
    }
    
    console.log(`Filtering ${disputes.length} disputes with search: "${search}"`);
    
    let filteredDisputes = [...disputes];
    
    // Debug the first dispute
    if (filteredDisputes.length > 0) {
      console.log("Sample dispute for debugging:", filteredDisputes[0]);
    }
    
    // Show all disputes or those without a status field
    filteredDisputes = filteredDisputes.filter(dispute => {
      const isOpenOrNoStatus = !dispute.dispute?.status || dispute.dispute?.status === 'open';
      return isOpenOrNoStatus;
    });
    
    console.log(`After status filter: ${filteredDisputes.length} disputes`);
    
    // Apply search filter
    if (search !== '') {
      filteredDisputes = filteredDisputes.filter(dispute => {
        // If dispute has email, check if it contains the search term
        const emailMatch = dispute.dispute?.email && 
          dispute.dispute.email.toLowerCase().includes(search.toLowerCase());
        
        // If dispute has name fields, check if they contain the search term
        const nameMatch = (dispute.first_name && dispute.first_name.toLowerCase().includes(search.toLowerCase())) ||
          (dispute.last_name && dispute.last_name.toLowerCase().includes(search.toLowerCase()));
        
        // If dispute has license plate, check if it contains the search term
        const licensePlateMatch = dispute.license_plate && 
          dispute.license_plate.toLowerCase().includes(search.toLowerCase());
        
        // If dispute has violation number, check if it contains the search term
        const violationNumberMatch = dispute.violation_number && 
          dispute.violation_number.toString().includes(search);
        
        return emailMatch || nameMatch || licensePlateMatch || violationNumberMatch;
      });
      
      console.log(`After search filter: ${filteredDisputes.length} disputes`);
    }
    
    // For client users, make sure they only see their own disputes
    if (user && user.type !== 'super' && user.client) {
      const beforeCount = filteredDisputes.length;
      filteredDisputes = filteredDisputes.filter(dispute => {
        const isClientDispute = dispute.client === user.client;
        return isClientDispute;
      });
      console.log(`Client user filter: ${beforeCount} -> ${filteredDisputes.length} disputes`);
    }
    
    // Apply sorting
    if (sortBy === 'dateAsc') {
      filteredDisputes = filteredDisputes.sort((a, b) => new Date(a.created_at || a.disputed_on || 0) - new Date(b.created_at || b.disputed_on || 0));
    }
    if (sortBy === 'dateDesc') {
      filteredDisputes = filteredDisputes.sort((a, b) => new Date(b.created_at || b.disputed_on || 0) - new Date(a.created_at || a.disputed_on || 0));
    }
    if (sortBy === 'nameAsc') {
      filteredDisputes = filteredDisputes.sort((a, b) => {
        const nameA = `${a.first_name || ''} ${a.last_name || ''}`.trim().toLowerCase();
        const nameB = `${b.first_name || ''} ${b.last_name || ''}`.trim().toLowerCase();
        return nameA.localeCompare(nameB);
      });
    }
    if (sortBy === 'nameDesc') {
      filteredDisputes = filteredDisputes.sort((a, b) => {
        const nameA = `${a.first_name || ''} ${a.last_name || ''}`.trim().toLowerCase();
        const nameB = `${b.first_name || ''} ${b.last_name || ''}`.trim().toLowerCase();
        return nameB.localeCompare(nameA);
      });
    }
    if (sortBy === 'amountAsc') {
      filteredDisputes = filteredDisputes.sort((a, b) => parseFloat(a.total || 0) - parseFloat(b.total || 0));
    }
    if (sortBy === 'amountDesc') {
      filteredDisputes = filteredDisputes.sort((a, b) => parseFloat(b.total || 0) - parseFloat(a.total || 0));
    }
    
    console.log(`Final filtered disputes: ${filteredDisputes.length}`);
    return filteredDisputes;
  };
  
  // Function to get paginated disputes
  const getPaginatedDisputes = () => {
    const filtered = filterDisputes();
    const startIndex = (page - 1) * pageSize;
    return filtered.slice(startIndex, startIndex + pageSize);
  };
  
  // Function to handle page size changes
  const handlePageSizeChange = (newSize) => {
    setPageSize(newSize);
    // Save to localStorage for persistence
    localStorage.setItem('disputes_page_size', newSize.toString());
    // Reset to first page when changing page size
    setPage(1);
  };
  
  // Function to handle dispute adjustment
  const handleAdjustDispute = (citation, percentage = 50) => {
    // Calculate adjustment amount
    const amount = parseFloat(citation.total) * (percentage / 100);
    setSelectedDispute(citation);
    setShowAdjustModal(true);
  };
  
  // Function to handle dispute acceptance
  const handleAcceptDispute = (citation) => {
    // Call the actual accept action from props
    if (acceptDispute) {
      acceptDispute(citation);
    }
  };
  
  // Function to handle dispute rejection
  const handleRejectDispute = (citation) => {
    // Call the actual reject action from props
    if (rejectDispute) {
      rejectDispute(citation);
    }
  };
  
  // Function to handle recommendation rating
  const handleAiRating = (disputeId, isPositive) => {
    if (!disputeId) return;
    
    // Find the dispute by ID
    const dispute = filterDisputes().find(d => d.id === disputeId);
    
    setAiRatings(prevRatings => {
      const currentRating = prevRatings[disputeId] || { positive: false, negative: false };
      
      // If clicking the same button that's already active, toggle it off
      if (isPositive && currentRating.positive) {
        return {
          ...prevRatings,
          [disputeId]: { positive: false, negative: false }
        };
      } else if (!isPositive && currentRating.negative) {
        return {
          ...prevRatings,
          [disputeId]: { positive: false, negative: false }
        };
      }
      
      // Otherwise, set the new rating and ensure the opposite rating is off
      return {
        ...prevRatings,
        [disputeId]: { positive: isPositive, negative: !isPositive }
      };
    });
    
    // Save basic rating then open detailed feedback form
    console.log(`AI Rating for dispute ${disputeId}: ${isPositive ? 'Positive' : 'Negative'}`);
    
    // Set current dispute for the feedback form
    setCurrentFeedbackDispute(dispute);
    setShowFeedbackForm(true);
    setFeedbackText('');
    setFeedbackSubmitted(false);
  };
  
  // Function to toggle dropdowns
  
  // Function to apply all recommendations above threshold
  const applyAllRecommendations = () => {
    const filteredDisputes = filterDisputes();
    
    // Process each filtered dispute
    filteredDisputes.forEach(dispute => {
      const recommendedAction = getRecommendedAction(dispute);
      
      // Only apply if confidence is above threshold
      if (recommendedAction.confidence >= confidenceThreshold) {
        // Perform action based on recommendation
        if (recommendedAction.action.includes("Adjust")) {
          handleAdjustDispute(dispute, 50);
        } else if (recommendedAction.action.includes("Accept")) {
          handleAcceptDispute(dispute);
        } else if (recommendedAction.action.includes("Reject")) {
          handleRejectDispute(dispute);
        }
      }
    });
    
    // Close dropdown after applying
    setShowConfidenceDropdown(false);
  };
  
  // Function to get recommended action for a dispute
  const getRecommendedAction = (dispute) => {
    const email = dispute?.dispute?.email;
    if (!email) {
      return {
        action: "View details",
        reason: "Insufficient data to make a recommendation",
        confidence: 30,
        similarCasesCount: 0
      };
    }
    
    // If we already have analysis in local state
    if (dispute.aiAnalysis) {
      return {
        action: dispute.aiAnalysis.recommendation,
        reason: dispute.aiAnalysis.reasoning,
        confidence: dispute.aiAnalysis.validityPercentage,
        adjustmentPercentage: dispute.aiAnalysis.adjustmentPercentage || 50,
        similarCasesCount: dispute.aiAnalysis.similarCasesCount || 0
      };
    }
    
    // Return deterministic recommendation based on email
    const hashCode = (str) => {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = ((hash << 5) - hash) + str.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
      }
      return hash;
    };
    
    const hash = Math.abs(hashCode(email));
    const score = (hash % 100) + 1; // 1-100
    
    // Generate a deterministic similar cases count based on the dispute
    const locationHash = dispute.location_name ? 
      hashCode(dispute.location_name) : 
      hashCode(email);
    const similarCasesCount = Math.abs(locationHash % 15) + 3; // 3-17 similar cases
    
    if (score > 75) {
      return {
        action: "Accept Dispute",
        reason: "High trust score and consistent evidence supports claim",
        confidence: 85,
        adjustmentPercentage: 0,
        similarCasesCount
      };
    } else if (score > 40) {
      return {
        action: "Adjust by 50%",
        reason: "Partial evidence supports some reduction",
        confidence: 72,
        adjustmentPercentage: 50,
        similarCasesCount
      };
    } else {
      return {
        action: "Reject Dispute",
        reason: "Insufficient evidence to support the claim",
        confidence: 67,
        adjustmentPercentage: 0,
        similarCasesCount
      };
    }
  };
  
  // Define small stats data
  const smallStats = [
    {
      label: "Open Disputes",
      value: metrics.openDisputes,
      percentage: "",
      increase: false,
      chartLabels: [null, null, null, null, null],
      attrs: { md: "6", sm: "6" },
      datasets: [
        {
          label: "Today",
          fill: "start",
          borderWidth: 1.5,
          backgroundColor: "rgba(249, 138, 1, 0.1)",
          borderColor: "rgba(249, 138, 1, 0.5)",
          data: [3, 2, 5, 4, metrics.openDisputes]
        }
      ]
    },
    {
      label: "Adjusted & Unpaid",
      value: metrics.adjustedUnpaid,
      percentage: "",
      increase: false,
      chartLabels: [null, null, null, null, null],
      attrs: { md: "6", sm: "6" },
      datasets: [
        {
          label: "Today",
          fill: "start",
          borderWidth: 1.5,
          backgroundColor: "rgba(0, 123, 255, 0.1)",
          borderColor: "rgba(0, 123, 255, 0.5)",
          data: [2, 1, 3, 2, metrics.adjustedUnpaid]
        }
      ]
    },
    {
      label: "Avg. Resolution Time",
      value: `${metrics.avgResolutionTime} hrs`,
      percentage: "",
      increase: true,
      chartLabels: [null, null, null, null, null],
      attrs: { md: "4", sm: "6" },
      datasets: [
        {
          label: "Today",
          fill: "start",
          borderWidth: 1.5,
          backgroundColor: "rgba(255, 180, 0, 0.1)",
          borderColor: "rgba(255, 180, 0, 0.5)",
          data: [2, 3, 3, 2, 4]
        }
      ]
    },
    {
      label: "Disputes Accepted",
      value: `${metrics.acceptedPercentage}%`,
      percentage: `${metrics.acceptedPercentage}%`,
      increase: true,
      chartLabels: [null, null, null, null, null],
      attrs: { md: "4", sm: "6" },
      datasets: [
        {
          label: "Today",
          fill: "start",
          borderWidth: 1.5,
          backgroundColor: "rgba(23, 198, 113, 0.1)",
          borderColor: "rgba(23, 198, 113, 0.5)",
          data: [3, 2, 3, 4, 5]
        }
      ]
    },
    {
      label: "Disputes Rejected",
      value: `${metrics.rejectedPercentage}%`,
      percentage: `${metrics.rejectedPercentage}%`,
      increase: false,
      chartLabels: [null, null, null, null, null],
      attrs: { md: "4", sm: "6" },
      datasets: [
        {
          label: "Today",
          fill: "start",
          borderWidth: 1.5,
          backgroundColor: "rgba(200, 23, 18, 0.1)",
          borderColor: "rgba(200, 23, 18, 0.5)",
          data: [4, 3, 2, 3, 4]
        }
      ]
    }
  ];

  // Add the AI Analyze function
  const handleAnalyzeDispute = (dispute) => {
    setSelectedForAnalysis(dispute);
    setShowAnalysisModal(true);
  };

  return (
    <Container fluid className="main-content-container px-4">
      {!isDisputeAssistantEnabled ? (
        <Row className="mt-5">
          <Col md="12" className="text-center">
            <div className="mb-4">
              <FontAwesomeIcon icon={faBrain} style={{ color: '#818ea3', fontSize: '48px' }} />
            </div>
            <h3>Dispute Assistant is not enabled for your organization</h3>
            <p className="text-muted mb-1">
              The Dispute Assistant feature requires activation for your organization.
            </p>
            <p className="text-muted mb-4">
              Please contact your account manager to enable this powerful AI-powered feature.
            </p>
            <Button
              theme="accent"
              onClick={() => window.history.back()}
              className="mt-3"
            >
              Go Back
            </Button>
          </Col>
        </Row>
      ) : (
        <>
          <style>
            {`
              .dropdown-toggle {
                white-space: nowrap;
              }
              
              /* Tooltip styles */
              .tooltip-container {
                position: relative;
            display: inline-block;
          }
          
          .tooltip-icon {
                cursor: pointer;
            color: #818ea3;
            transition: color 0.2s ease;
          }
          
              .tooltip-container:hover .tooltip-icon {
            color: #21AA73;
          }
          
          .tooltip-content {
            position: absolute;
                z-index: 2050;
                padding: 10px 12px;
                background-color: white;
            border-radius: 4px;
                box-shadow: 0 2px 8px rgba(0,0,0,0.15);
            border: 1px solid #eaedf3;
            font-size: 12px;
                max-width: 250px;
                display: none;
                top: auto;
                bottom: 100%;
                left: 0;
                margin-bottom: 5px;
                min-width: 200px;
          }
          
          .tooltip-content.right {
            left: auto;
            right: 0;
          }
          
          .tooltip-container:hover .tooltip-content {
                display: block;
          }
          
              /* Custom tooltip style for backward compatibility */
              .custom-tooltip {
            position: absolute;
                z-index: 2050;
                padding: 8px 12px;
                background-color: white;
                border-radius: 4px;
                box-shadow: 0 2px 8px rgba(0,0,0,0.15);
                border: 1px solid #eaedf3;
                font-size: 12px;
                max-width: 250px;
                display: none;
              }
              
              /* Tooltip arrow */
              .custom-tooltip:after {
            content: "";
            position: absolute;
                top: -5px;
            right: 10px;
                border-width: 0 5px 5px;
                border-style: solid;
                border-color: transparent transparent white;
            transform: rotate(45deg);
          }
          
          .tooltip-title {
            font-weight: 600;
            margin-bottom: 5px;
            color: #3d5170;
            font-size: 13px;
          }
          
          /* Tab Styles */
          .nav-tabs {
            border-bottom: 1px solid #eaedf3;
          }
          
          /* Custom styles now handled by EnhancedDateRangePicker */
          .react-datepicker-popper {
            z-index: 9999 !important;
          }
          
          .datepicker-calendar-with-apply {
            z-index: 9999 !important;
          }
        `}
      </style>
      {/* Page Header */}
      <Row noGutters className="page-header py-4">
        <Col lg="9" md="8" sm="12" className="mb-2">
          <PageTitle 
            title="Dispute Assistant" 
            md="12" 
            className="ml-sm-auto mr-sm-auto" 
          />
        </Col>
        <Col lg="3" md="4" className="d-flex justify-content-end pr-0">
          <Button
            theme="light"
            size="sm"
            style={{
              fontWeight: '500',
              boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
              display: 'flex',
              alignItems: 'center',
              marginRight: '10px'
            }}
            onClick={() => setShowStatsModal(true)}
          >
            <FontAwesomeIcon icon={faChartPie} className="mr-2" />
            View Stats
          </Button>
              
              {/* Make historical analysis button available to all users, not just super admins */}
              <Button
                theme="primary"
                size="sm"
                style={{
                  fontWeight: '500',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                  display: 'flex',
                  alignItems: 'center',
                  marginRight: '10px'
                }}
                onClick={() => {
                  try {
                    openClientSelector();
                  } catch (error) {
                    console.error("Error opening client selector:", error);
                    alert("An error occurred. Please try again.");
                  }
                }}
                disabled={analyzing}
              >
                <FontAwesomeIcon icon={faBrain} className="mr-2" />
                {analyzing ? 'Analyzing...' : 'Analyze Historical Disputes'}
              </Button>
              
          <Button
            theme="accent"
            size="sm"
            style={{
              fontWeight: '500',
              boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
              display: 'flex',
              alignItems: 'center'
            }}
            onClick={() => {
              setActiveAiTab("team");
              setShowAiInsightsModal(true);
            }}
          >
            <FontAwesomeIcon icon={faRobot} className="mr-2" />
            View AI Insights
          </Button>
        </Col>
      </Row>

      {/* Assistant Tip */}
      <Card className="mb-4" style={{
        backgroundColor: 'rgba(33, 170, 115, 0.06)',
        border: '1px dashed rgba(33, 170, 115, 0.3)',
        borderRadius: '6px',
        overflow: 'hidden'
      }}>
        <CardBody className="p-3">
          <div className="d-flex align-items-center">
            <div style={{
              backgroundColor: 'rgba(33, 170, 115, 0.15)',
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '16px'
            }}>
              <FontAwesomeIcon icon={faRobot} style={{ color: '#21AA73', fontSize: '18px' }} />
            </div>
            <div style={{ flex: 1 }}>
              <h6 className="mb-1 font-weight-bold" style={{ color: '#21AA73' }}>Let your assistant take over - save time now!</h6>
              <p className="mb-0" style={{ fontSize: '13px', color: '#495057' }}>
                Your AI assistant can handle routine disputes, saving you up to 80% of your time. Enable auto-resolution to process disputes automatically.
              </p>
            </div>
            <Button
              theme="success"
              size="sm"
              outline
              style={{
                marginRight: '16px',
                fontWeight: '500',
                borderWidth: '2px',
                boxShadow: 'none'
              }}
              onClick={() => setShowAutoResolutionModal(true)}
            >
              Enable Auto-Resolution
            </Button>
          </div>
        </CardBody>
      </Card>

      {/* Date Range & Client Filter */}
      <Row className="mb-4">
        <Col md={6} lg={4} className="mb-3 mb-md-0">
          <Card className="mb-0">
            <CardBody className="p-3">
              <div className="d-flex align-items-center mb-2">
                <h6 className="mb-0 mr-auto">Date Range</h6>
                <div className="ml-auto">
                  <ButtonGroup className="btn-group-sm" style={{display: 'flex', flexWrap: 'wrap', gap: '4px'}}>
                    <Button theme="light" size="sm" style={{fontSize: '11px', color: '#21AA73', borderColor: 'rgba(33, 170, 115, 0.3)'}} onClick={() => {
                      const today = startOfDay(new Date());
                      const todayEnd = endOfDay(new Date());
                      setStartDate(today);
                      setEndDate(todayEnd);
                      localStorage.setItem('enforcePlus_startDate', today.toISOString());
                      localStorage.setItem('enforcePlus_endDate', todayEnd.toISOString());
                    }}>Today</Button>
                    <Button theme="light" size="sm" style={{fontSize: '11px', color: '#21AA73', borderColor: 'rgba(33, 170, 115, 0.3)'}} onClick={() => {
                      const yesterday = startOfDay(sub(new Date(), { days: 1 }));
                      const yesterdayEnd = endOfDay(sub(new Date(), { days: 1 }));
                      setStartDate(yesterday);
                      setEndDate(yesterdayEnd);
                      localStorage.setItem('enforcePlus_startDate', yesterday.toISOString());
                      localStorage.setItem('enforcePlus_endDate', yesterdayEnd.toISOString());
                    }}>Yesterday</Button>
                  </ButtonGroup>
                </div>
              </div>
              
              <EnhancedDateRangePicker
                startDate={startDate}
                endDate={endDate}
                onStartDateChange={(date) => {
                  setStartDate(date);
                  if (date) {
                    localStorage.setItem('enforcePlus_startDate', date.toISOString());
                  }
                }}
                onEndDateChange={(date) => {
                  setEndDate(date);
                  if (date) {
                    localStorage.setItem('enforcePlus_endDate', date.toISOString());
                  }
                }}
                startLabel="From"
                endLabel="To"
                maxDate={new Date()}
              />
              
              <div className="d-flex justify-content-between">
                <ButtonGroup className="btn-group-sm" style={{display: 'flex', flexWrap: 'wrap', gap: '4px'}}>
                  <Button theme="light" size="sm" style={{fontSize: '11px', color: '#21AA73', borderColor: 'rgba(33, 170, 115, 0.3)'}} onClick={() => {
                    const weekStart = startOfDay(sub(new Date(), { days: 6 }));
                    const today = endOfDay(new Date());
                    setStartDate(weekStart);
                    setEndDate(today);
                    localStorage.setItem('enforcePlus_startDate', weekStart.toISOString());
                    localStorage.setItem('enforcePlus_endDate', today.toISOString());
                  }}>Last 7d</Button>
                  <Button theme="light" size="sm" style={{fontSize: '11px', color: '#21AA73', borderColor: 'rgba(33, 170, 115, 0.3)'}} onClick={() => {
                    const monthStart = startOfDay(sub(new Date(), { days: 29 }));
                    const today = endOfDay(new Date());
                    setStartDate(monthStart);
                    setEndDate(today);
                    localStorage.setItem('enforcePlus_startDate', monthStart.toISOString());
                    localStorage.setItem('enforcePlus_endDate', today.toISOString());
                  }}>Last 30d</Button>
                  <Button theme="light" size="sm" style={{fontSize: '11px', color: '#21AA73', borderColor: 'rgba(33, 170, 115, 0.3)'}} onClick={() => {
                    const thisMonthStart = startOfMonth(new Date());
                    const thisMonthEnd = endOfMonth(new Date());
                    setStartDate(thisMonthStart);
                    setEndDate(thisMonthEnd);
                    localStorage.setItem('enforcePlus_startDate', thisMonthStart.toISOString());
                    localStorage.setItem('enforcePlus_endDate', thisMonthEnd.toISOString());
                  }}>This Month</Button>
                </ButtonGroup>
              </div>
            </CardBody>
          </Card>
        </Col>
        
        {user?.type === 'super' && (
          <Col md={3} lg={3}>
            <Select
              id="feClients"
              className="basic-select"
              classNamePrefix="select"
              placeholder={clientsLoading ? "Loading clients..." : "All clients"}
              isDisabled={clientsLoading}
              isClearable={false}
              isSearchable={true}
              value={client === 'all' 
                ? { value: 'all', label: 'All clients' } 
                : localClients && localClients.length > 0 && localClients.find(c => c.id === client) 
                  ? { value: client, label: localClients.find(c => c.id === client).name || "Unnamed Client" }
                  : { value: 'all', label: 'All clients' }
              }
              onChange={(selectedOption) => setClient(selectedOption.value)}
              options={[
                { value: 'all', label: 'All clients' },
                ...(localClients && localClients.length > 0 
                  ? localClients
                      .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
                      .map(c => ({
                        value: c.id,
                        label: c.name || "Unnamed Client"
                      })) 
                  : [])
              ]}
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: state.isFocused ? 'rgba(33, 170, 115, 0.4)' : '#dfe3e9',
                  boxShadow: state.isFocused ? '0 0 0 1px rgba(33, 170, 115, 0.4)' : null,
                  '&:hover': {
                    borderColor: 'rgba(33, 170, 115, 0.4)'
                  }
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected 
                    ? 'rgba(33, 170, 115, 0.1)' 
                    : state.isFocused 
                      ? 'rgba(33, 170, 115, 0.05)' 
                      : null,
                  color: state.isSelected ? '#21AA73' : base.color
                }),
                menuList: (base) => ({
                  ...base,
                  padding: '5px'
                }),
                menu: (base) => ({
                  ...base,
                  boxShadow: '0 3px 12px rgba(0,0,0,0.08)',
                  borderRadius: '6px',
                  border: '1px solid #eaedf3',
                  backgroundColor: '#fff'
                }),
                indicatorSeparator: () => ({
                  display: 'none'
                }),
                dropdownIndicator: (base, state) => ({
                  ...base,
                  color: state.isFocused ? '#21AA73' : '#818ea3',
                  transition: 'color 0.2s ease',
                  '&:hover': {
                    color: '#21AA73'
                  }
                }),
                singleValue: (base) => ({
                  ...base,
                  color: '#495057'
                })
              }}
            />
          </Col>
        )}
        
        {/* For non-super users, make search take up the whole row */}
        <Col md={user?.type === 'super' ? 3 : 12} lg={user?.type === 'super' ? 5 : 8}>
          <div className="search-container" style={{ position: 'relative', maxWidth: '100%' }}>
            <input
              type="text"
              placeholder="Search disputes..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                width: '100%',
                padding: '8px 32px 8px 36px',
                fontSize: '14px',
                border: '1px solid #dfe3e9',
                borderRadius: '4px',
                backgroundColor: '#f8f9fa',
                transition: 'all 0.2s ease',
                outline: 'none'
              }}
              onFocus={(e) => {
                e.target.style.backgroundColor = '#fff';
                e.target.style.boxShadow = '0 0 0 0.2rem rgba(33, 170, 115, 0.1)';
                e.target.style.borderColor = 'rgba(33, 170, 115, 0.4)';
              }}
              onBlur={(e) => {
                e.target.style.backgroundColor = '#f8f9fa';
                e.target.style.boxShadow = 'none';
                e.target.style.borderColor = '#dfe3e9';
              }}
            />
            <FontAwesomeIcon 
              icon={faSearch} 
              style={{
                position: 'absolute',
                left: '12px',
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#818ea3',
                transition: 'color 0.2s ease'
              }}
            />
            {search && (
              <FontAwesomeIcon 
                icon={faTimes}
                style={{
                  position: 'absolute',
                  right: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#818ea3',
                  cursor: 'pointer',
                  transition: 'color 0.2s ease'
                }}
                onClick={() => setSearch('')}
                onMouseEnter={(e) => e.currentTarget.style.color = '#21AA73'}
                onMouseLeave={(e) => e.currentTarget.style.color = '#818ea3'}
              />
            )}
          </div>
        </Col>
      </Row>

      {/* Active Disputes Card */}
      <Card small className="mb-4" style={{
        borderRadius: '6px', 
        boxShadow: '0 1px 10px rgba(0,0,0,0.05)', 
        border: '1px solid #eaedf3',
        margin: '0 0 20px 0'
      }}>
        <CardHeader className="border-bottom">
          <h6 className="m-0 font-weight-bold d-flex align-items-center">
            <FontAwesomeIcon icon={faExclamationTriangle} className="mr-2" style={{color: '#F98A01', opacity: 0.8}} />
            Active Disputes ({filterDisputes().length})
          </h6>
        </CardHeader>
        <CardBody className="p-0">
          {loading ? (
            <div className="text-center py-5">
              <ActivityIndicator size="large" />
              <p className="mt-3 text-muted">Loading disputes...</p>
            </div>
          ) : filterDisputes().length === 0 ? (
            <div className="text-center py-5">
              <FontAwesomeIcon icon={faCheckCircle} size="2x" style={{color: '#21AA73', marginBottom: '10px', opacity: 0.8}} />
              <h6>No active disputes</h6>
              <p style={{fontSize: '12px', color: '#9EA0A5'}}>All disputes have been resolved for the selected period.</p>
            </div>
          ) : (
            <>
              <div className="table-responsive" style={{ minHeight: '300px' }}>
                <table className="table mb-0">
                  <thead className="bg-light sticky-top">
                    <tr>
                      <th scope="col" className="border-0" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                        <div onClick={() => setSortBy(sortBy !== 'dateAsc' ? 'dateAsc' : 'dateDesc')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                          Date Disputed
                          {sortBy === 'dateAsc' && <FontAwesomeIcon icon={faSortUp} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                          {sortBy === 'dateDesc' && <FontAwesomeIcon icon={faSortDown} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                        </div>
                      </th>
                      <th scope="col" className="border-0" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                        <div onClick={() => setSortBy(sortBy !== 'nameAsc' ? 'nameAsc' : 'nameDesc')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                          Name
                          {sortBy === 'nameAsc' && <FontAwesomeIcon icon={faSortUp} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                          {sortBy === 'nameAsc' && <FontAwesomeIcon icon={faArrowUp} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                          {sortBy === 'nameDesc' && <FontAwesomeIcon icon={faArrowDown} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                        </div>
                      </th>
                      <th scope="col" className="border-0" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                        <div onClick={() => setSortBy(sortBy !== 'amountAsc' ? 'amountAsc' : 'amountDesc')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                          Amount
                          {sortBy === 'amountAsc' && <FontAwesomeIcon icon={faArrowUp} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                          {sortBy === 'amountDesc' && <FontAwesomeIcon icon={faArrowDown} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                        </div>
                      </th>
                      <th scope="col" className="border-0" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>Trust</th>
                      <th scope="col" className="border-0" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>Recommended Action</th>
                      <th scope="col" className="border-0" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>Rate AI</th>
                      <th scope="col" className="border-0" style={{color: '#818ea3', fontWeight: 500, fontSize: 13, width: '160px'}}>
                        <div className="d-flex justify-content-end align-items-center">
                          <div className="position-relative" ref={applyButtonRef}>
                            <Button
                              size="sm"
                              theme="success"
                              id="apply-all-button"
                              style={{
                                boxShadow: 'none',
                                border: '1px solid #21AA73',
                                borderRadius: '4px',
                                fontWeight: '500',
                                padding: '6px 12px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                fontSize: '12px',
                                transition: 'all 0.2s ease',
                                backgroundColor: '#21AA73'
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowConfidenceDropdown(!showConfidenceDropdown);
                              }}
                            >
                              <FontAwesomeIcon icon={faRobot} style={{marginRight: '6px', fontSize: '12px'}} />
                              AI Apply All {confidenceThreshold}%+
                              <FontAwesomeIcon icon={faCaretDown} style={{marginLeft: '6px', fontSize: '12px'}} />
                            </Button>
                            
                            {showConfidenceDropdown && (
                              <div 
                                id="confidence-dropdown"
                                ref={confidenceDropdownRef}
                                style={{
                                  position: 'absolute',
                                  top: '100%',
                                  right: 0,
                                  backgroundColor: '#fff',
                                  borderRadius: '4px',
                                  boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
                                  zIndex: 1050,
                                  marginTop: '5px',
                                  width: '300px',
                                  padding: '10px',
                                  border: '1px solid #eaedf3',
                                  maxHeight: '80vh',
                                  overflowY: 'auto'
                                }}
                              >
                                <div className="mb-2" style={{fontSize: '13px', fontWeight: '600'}}>
                                  Apply to disputes with confidence above:
                                </div>
                                <div className="d-flex flex-wrap mb-3">
                                  {[25, 35, 50, 65, 75, 85, 90, 100].map(value => {
                                    // Determine confidence level label
                                    let levelLabel = "";
                                    let levelColor = "";
                                    if (value >= 80) {
                                      levelLabel = "High";
                                      levelColor = "#21AA73";
                                    } else if (value >= 60) {
                                      levelLabel = "Medium";
                                      levelColor = "#F9A43F";
                                    } else {
                                      levelLabel = "Low";
                                      levelColor = "#C81712";
                                    }
                                    
                                    return (
                                      <div 
                                        key={value}
                                        onClick={() => setConfidenceThreshold(value)}
                                        style={{
                                          padding: '5px 10px',
                                          margin: '3px',
                                          borderRadius: '4px',
                                          cursor: 'pointer',
                                          backgroundColor: confidenceThreshold === value ? '#f2f2f2' : '#f8f9fa',
                                          border: `1px solid ${confidenceThreshold === value ? '#d1d5db' : '#eaedf3'}`,
                                          color: '#495057',
                                          fontWeight: confidenceThreshold === value ? '600' : '400',
                                          fontSize: '13px',
                                          display: 'flex',
                                          flexDirection: 'column',
                                          alignItems: 'center'
                                        }}
                                      >
                                        <span>{value}%</span>
                                        <span style={{fontSize: '10px', color: '#6c757d'}}>confidence</span>
                                      </div>
                                    );
                                  })}
                                </div>
                                <div className="d-flex justify-content-between">
                                  <Button
                                    size="sm"
                                    theme="light"
                                    style={{fontSize: '12px'}}
                                    onClick={() => setShowConfidenceDropdown(false)}
                                  >
                                    Cancel
                                  </Button>
                                  <Button
                                    size="sm"
                                    theme="success"
                                    style={{fontSize: '12px'}}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      applyAllRecommendations();
                                    }}
                                  >
                                    Apply to All
                                  </Button>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      const paginatedDisputes = getPaginatedDisputes();
                      console.log("Paginated disputes:", paginatedDisputes.length);
                      
                      if (paginatedDisputes.length === 0) {
                        return (
                          <tr>
                            <td colSpan="7" className="text-center py-4">
                              <p className="mb-0 text-muted">No disputes found.</p>
                              <p className="mb-0 text-muted" style={{fontSize: '13px'}}>Try adjusting your filters or date range.</p>
                            </td>
                          </tr>
                        );
                      }
                      
                      return paginatedDisputes.map((dispute, idx) => {
                        const score = getScoreForEmail(dispute.dispute?.email);
                        
                        return (
                          <tr key={dispute.id || idx} className="dispute-row" onClick={() => {
                            setSelectedDispute(dispute);
                            setShowQuickViewModal(true);
                          }}>
                            <td>
                              <div style={{fontSize: '13px'}}>{moment(dispute.disputed_on).format('MM/DD/YYYY')}</div>
                              <div style={{fontSize: '11px', color: '#818ea3'}}>{moment(dispute.disputed_on).format('h:mm a')}</div>
                            </td>
                            <td>
                              <div style={{fontSize: '13px', fontWeight: '500'}}>
                                {dispute.dispute?.name || 'Unknown'}
                                <div className="tooltip-container">
                                  <FontAwesomeIcon icon={faInfoCircle} className="tooltip-icon" />
                                  <div className="tooltip-content">
                                    <div className="tooltip-title">Dispute Reason</div>
                                    <div>{dispute.dispute?.reason || 'No reason provided'}</div>
                                  </div>
                                </div>
                              </div>
                              <div style={{fontSize: '11px', color: '#818ea3'}}>{dispute.dispute?.email || 'No email'}</div>
                            </td>
                            <td>
                              <div style={{fontSize: '14px', fontWeight: '500'}}>${parseFloat(dispute.total || 0).toFixed(2)}</div>
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <div
                                  style={{
                                    width: '32px',
                                    height: '32px',
                                    borderRadius: '50%',
                                    backgroundColor: 'white',
                                    border: `2px solid ${getTrustScoreColor(score)}`,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: '600',
                                    fontSize: '13px',
                                    color: getTrustScoreColor(score),
                                    marginRight: '8px'
                                  }}
                                >
                                  {score}
                                </div>
                              </div>
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <RecommendedAction
                                  email={dispute.dispute?.email}
                                      dispute={dispute}
                                  handleAccept={() => handleAcceptDispute(dispute)}
                                  handleReject={() => handleRejectDispute(dispute)}
                                  handleAdjust={() => handleAdjustDispute(dispute, 50)}
                                />
                                <div className="tooltip-container ml-2">
                                  <FontAwesomeIcon icon={faQuestionCircle} className="tooltip-icon" />
                                  <div className="tooltip-content right">
                                    <div className="tooltip-title">Recommendation Rationale</div>
                                    <div>
                                      <p className="mb-2">Based on analysis of similar cases and this customer's profile:</p>
                                      <ul className="pl-3 mb-0">
                                            <li className="mb-1">Trust score: {getScoreForEmail(dispute.dispute?.email)}/100</li>
                                        <li className="mb-1">Similar resolved cases: {Math.floor(5 + Math.random() * 10)}</li>
                                            <li className="mb-1">Evidence quality: {getScoreForEmail(dispute.dispute?.email) >= 75 ? 'High' : getScoreForEmail(dispute.dispute?.email) >= 60 ? 'Medium' : 'Low'}</li>
                                        <li className="mb-1">Previous dispute history: {Math.floor(Math.random() * 3)} disputes</li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div className="d-flex">
                                <Button
                                  size="sm"
                                  theme="light"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleAiRating(dispute.id, true);
                                  }}
                                  style={{
                                    border: dispute.aiRatingPositive ? '1px solid #21AA73' : '1px solid #eaedf3',
                                    backgroundColor: dispute.aiRatingPositive ? 'rgba(33, 170, 115, 0.1)' : 'white',
                                    color: dispute.aiRatingPositive ? '#21AA73' : '#818ea3',
                                    marginRight: '5px',
                                    padding: '0px 8px',
                                    height: '28px'
                                  }}
                                >
                                  <FontAwesomeIcon icon={faThumbsUp} />
                                </Button>
                                <Button
                                  size="sm"
                                  theme="light"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleAiRating(dispute.id, false);
                                  }}
                                  style={{
                                    border: dispute.aiRatingNegative ? '1px solid #C81712' : '1px solid #eaedf3',
                                    backgroundColor: dispute.aiRatingNegative ? 'rgba(200, 23, 18, 0.1)' : 'white',
                                    color: dispute.aiRatingNegative ? '#C81712' : '#818ea3',
                                    padding: '0px 8px',
                                    height: '28px'
                                  }}
                                >
                                  <FontAwesomeIcon icon={faThumbsDown} />
                                </Button>
                              </div>
                            </td>
                            <td>
                              <div className="d-flex justify-content-end">
                                <RowActions>
                                    <RowActions.Item onClick={(e) => {
                                      e.stopPropagation();
                                      handleAcceptDispute(dispute);
                                    }}>
                                      <FontAwesomeIcon icon={faCheckCircle} className="mr-2" style={{color: '#21AA73'}} />
                                      Accept Dispute
                                    </RowActions.Item>
                                    <RowActions.Item onClick={(e) => {
                                      e.stopPropagation();
                                      handleRejectDispute(dispute);
                                    }}>
                                      <FontAwesomeIcon icon={faTimesCircle} className="mr-2" style={{color: '#C81712'}} />
                                      Reject Dispute
                                    </RowActions.Item>
                                    <RowActions.Divider />
                                    <RowActions.Item onClick={(e) => {
                                      e.stopPropagation();
                                      handleAdjustDispute(dispute, 50);
                                    }}>
                                      <FontAwesomeIcon icon={faPercent} className="mr-2" style={{color: '#3498db'}} />
                                      Adjust Balance
                                    </RowActions.Item>
                                    <RowActions.Divider />
                                    <RowActions.Item onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedDispute(dispute);
                                      setShowQuickViewModal(true);
                                    }}>
                                      <FontAwesomeIcon icon={faEye} className="mr-2" style={{color: '#818ea3'}} />
                                      Quick View
                                    </RowActions.Item>
                                    <RowActions.Item onClick={(e) => {
                                      e.stopPropagation();
                                      handleAnalyzeDispute(dispute);
                                    }}>
                                      <FontAwesomeIcon icon={faBrain} className="mr-2" style={{color: '#6772e5'}} />
                                      AI Analyze Dispute
                                    </RowActions.Item>
                                    <RowActions.Item onClick={(e) => {
                                      e.stopPropagation();
                                      // Open the full view
                                      if (user?.type === 'super') {
                                            const recommendation = getRecommendedAction(dispute);
                                        const score = getScoreForEmail(dispute.dispute?.email);
                                        const aiData = encodeURIComponent(JSON.stringify({
                                          action: recommendation.action,
                                          confidence: recommendation.confidence,
                                          reason: recommendation.reason,
                                          trustScore: score
                                        }));
                                            window.location.href = `/citation/${dispute.violation_number || 'unknown'}?aiData=${aiData}`;
                                      } else {
                                            window.location.href = `/citation/${dispute.violation_number || 'unknown'}`;
                                      }
                                    }}>
                                      <FontAwesomeIcon icon={faExternalLinkAlt} className="mr-2" style={{color: '#818ea3'}} />
                                      View Full Citation
                                    </RowActions.Item>
                                  </RowActions>
                              </div>
                            </td>
                          </tr>
                        );
                      });
                    })()}
                  </tbody>
                </table>
              </div>
                  
                  {/* Pagination */}
                  <div className="p-3 border-top d-flex justify-content-between align-items-center">
                    <div style={{fontSize: '13px', color: '#818ea3'}}>
                      Showing {Math.min(((page - 1) * pageSize) + 1, filterDisputes().length)} to {Math.min(page * pageSize, filterDisputes().length)} of {filterDisputes().length} disputes
                    </div>
                    <Pagination
                      data={filterDisputes()}
                      pageSize={pageSize}
                      page={page}
                      onPageChange={(newPage) => setPage(newPage)}
                      onPageSizeChange={handlePageSizeChange}
                    />
              </div>
              {/* Add extra space at the bottom when there's only one item to ensure dropdowns have room to open */}
              {filterDisputes().length <= 1 && <div style={{height: '150px'}}></div>}
            </>
          )}
        </CardBody>
      </Card>

          {/* AI Insights Modal */}
          <Modal open={showAiInsightsModal} toggle={() => setShowAiInsightsModal(false)} size="lg">
            <ModalHeader toggle={() => setShowAiInsightsModal(false)}>
              <div className="d-flex align-items-center">
                <FontAwesomeIcon icon={faRobot} className="mr-2" style={{color: '#3498db'}} />
                <div>
                  <div>AI Insights</div>
                  <div style={{fontSize: '12px', color: '#818ea3', fontWeight: 'normal'}}>Machine learning-powered analysis of dispute patterns</div>
                </div>
              </div>
            </ModalHeader>
            <ModalBody className="p-4" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              <Nav tabs className="mb-4">
            <NavItem>
              <NavLink
                    className={activeAiTab === "recommended" ? "active" : ""}
                    onClick={() => setActiveAiTab("recommended")}
                    style={{cursor: 'pointer'}}
              >
                    <FontAwesomeIcon icon={faLightbulb} className="mr-2" />
                    Recommendations
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                    className={activeAiTab === "team" ? "active" : ""}
                    onClick={() => setActiveAiTab("team")}
                    style={{cursor: 'pointer'}}
                  >
                    <FontAwesomeIcon icon={faUsers} className="mr-2" />
                    Team Analysis
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeAiTab === "approach" ? "active" : ""}
                    onClick={() => setActiveAiTab("approach")}
                    style={{cursor: 'pointer'}}
                  >
                    <FontAwesomeIcon icon={faClipboardCheck} className="mr-2" />
                    Approach Guidance
              </NavLink>
            </NavItem>
          </Nav>
          
              {activeAiTab === "recommended" && (
                <Card className="mb-4">
                  <CardHeader className="border-bottom">
                    <h6 className="m-0 font-weight-bold">Efficient Processing Recommendations</h6>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col md="4" className="mb-4">
                        <div className="text-center">
                    <div style={{
                            width: '60px',
                            height: '60px',
                      borderRadius: '50%',
                      backgroundColor: 'rgba(33, 170, 115, 0.1)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                            margin: '0 auto 15px auto'
                    }}>
                            <FontAwesomeIcon icon={faRobot} style={{color: '#21AA73', fontSize: '24px'}} />
                    </div>
                          <h6 className="font-weight-bold mb-1">Auto-Resolution</h6>
                          <p className="text-muted mb-2" style={{fontSize: '13px'}}>Let AI handle routine disputes</p>
                          <Button 
                            size="sm" 
                            theme="success" 
                            outline
                            onClick={() => setShowAutoResolutionModal(true)}
                          >
                            Configure
                          </Button>
                    </div>
                      </Col>
                      <Col md="4" className="mb-4">
                        <div className="text-center">
                    <div style={{
                            width: '60px',
                            height: '60px',
                      borderRadius: '50%',
                            backgroundColor: 'rgba(52, 152, 219, 0.1)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                            margin: '0 auto 15px auto'
                    }}>
                            <FontAwesomeIcon icon={faSearchDollar} style={{color: '#3498db', fontSize: '24px'}} />
                    </div>
                          <h6 className="font-weight-bold mb-1">Bulk Apply</h6>
                          <p className="text-muted mb-2" style={{fontSize: '13px'}}>Apply high-confidence decisions</p>
                          <Button 
                            size="sm" 
                            theme="primary" 
                            outline
                            onClick={() => setShowConfidenceDropdown(true)}
                          >
                            Set Threshold
                          </Button>
                    </div>
                      </Col>
                      <Col md="4" className="mb-4">
                        <div className="text-center">
                    <div style={{
                            width: '60px',
                            height: '60px',
                      borderRadius: '50%',
                            backgroundColor: 'rgba(249, 164, 63, 0.1)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                            margin: '0 auto 15px auto'
                    }}>
                            <FontAwesomeIcon icon={faBrain} style={{color: '#F9A43F', fontSize: '24px'}} />
                    </div>
                          <h6 className="font-weight-bold mb-1">Patterns Analysis</h6>
                          <p className="text-muted mb-2" style={{fontSize: '13px'}}>Identify fraud patterns</p>
                          <Button 
                            size="sm" 
                            theme="warning" 
                            outline
                            onClick={runHistoricalAnalysis}
                            disabled={analyzing}
                          >
                            {analyzing ? 'Analyzing...' : 'Analyze'}
                          </Button>
                    </div>
                      </Col>
                    </Row>
                    
                    <div className="mt-3">
                      <h6 className="mb-3">Daily AI Insights</h6>
                      <div className="border rounded p-3 mb-3" style={{backgroundColor: 'rgba(33, 170, 115, 0.05)'}}>
                        <div className="d-flex">
                          <FontAwesomeIcon icon={faChartLine} className="mr-3 mt-1" style={{color: '#21AA73'}} />
                          <div>
                            <p className="mb-1" style={{fontWeight: '500'}}>High trust disputes up 12% this week</p>
                            <p className="mb-0" style={{fontSize: '13px', color: '#495057'}}>
                              There has been a 12% increase in the number of disputes with high trust scores. This suggests improved user verification may be working.
                            </p>
                  </div>
                </div>
                  </div>
                      
                      <div className="border rounded p-3 mb-3" style={{backgroundColor: 'rgba(249, 164, 63, 0.05)'}}>
                        <div className="d-flex">
                          <FontAwesomeIcon icon={faExclamationTriangle} className="mr-3 mt-1" style={{color: '#F9A43F'}} />
                          <div>
                            <p className="mb-1" style={{fontWeight: '500'}}>Similar phrasing detected in 7 disputes</p>
                            <p className="mb-0" style={{fontSize: '13px', color: '#495057'}}>
                              Seven recent disputes contain nearly identical phrasing about "payment system errors." Consider reviewing these cases together.
                            </p>
                </div>
              </div>
            </div>
                      
                      <div className="border rounded p-3" style={{backgroundColor: 'rgba(200, 23, 18, 0.05)'}}>
                        <div className="d-flex">
                          <FontAwesomeIcon icon={faExclamation} className="mr-3 mt-1" style={{color: '#C81712'}} />
                          <div>
                            <p className="mb-1" style={{fontWeight: '500'}}>Potential fraud cluster identified</p>
                            <p className="mb-0" style={{fontSize: '13px', color: '#495057'}}>
                              Three disputes from similar email domains show evidence of coordinated claims. AI recommends rejection based on historical patterns.
                            </p>
                    </div>
                  </div>
                  </div>
                  </div>
                  </CardBody>
                </Card>
              )}
              
              {activeAiTab === "team" && (
                <Card className="mb-4">
                  <CardHeader className="border-bottom">
                    <h6 className="m-0 font-weight-bold">Team Performance Analysis</h6>
                  </CardHeader>
                  <CardBody>
                    <div className="text-center py-5">
                      <FontAwesomeIcon icon={faUsers} style={{ fontSize: '40px', color: '#e9ecef', marginBottom: '15px' }} />
                      <p className="text-muted">Team performance analytics will be available after more team members process disputes.</p>
                    </div>
                  </CardBody>
                </Card>
              )}
              
              {activeAiTab === "approach" && (
                <Card className="mb-4">
                  <CardHeader className="border-bottom">
                    <h6 className="m-0 font-weight-bold">Approach Suggestions</h6>
                  </CardHeader>
                  <CardBody>
                    <p className="text-muted">Based on AI analysis of dispute patterns, here are recommended approaches:</p>
                    
                    <div className="border rounded p-3 mb-3">
                      <h6 className="mb-2" style={{color: '#21AA73'}}>
                        <FontAwesomeIcon icon={faCheckCircle} className="mr-2" />
                        Verify Receipt Authenticity
                      </h6>
                      <p className="mb-0" style={{fontSize: '14px'}}>
                        For disputes with receipt evidence, check for metadata timestamps and verify formatting matches known merchant receipts. Look for transaction IDs that can be verified with merchants.
                      </p>
              </div>
              
                    <div className="border rounded p-3 mb-3">
                      <h6 className="mb-2" style={{color: '#3498db'}}>
                        <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />
                        Cross-Reference Error Reports
                      </h6>
                      <p className="mb-0" style={{fontSize: '14px'}}>
                        When customers report payment system errors, cross-reference with known system outages or error logs. Multiple reports from different customers at the same location/time increase credibility.
                      </p>
                </div>
                
                    <div className="border rounded p-3">
                      <h6 className="mb-2" style={{color: '#F9A43F'}}>
                        <FontAwesomeIcon icon={faExclamationTriangle} className="mr-2" />
                        Check for Coordinated Claims
                      </h6>
                      <p className="mb-0" style={{fontSize: '14px'}}>
                        Be alert to multiple disputes with similar phrasing from related email domains or IP addresses. These patterns often indicate coordinated attempts to exploit the dispute system.
                      </p>
                  </div>
                  </CardBody>
                </Card>
              )}
            </ModalBody>
            <ModalFooter>
              <Button theme="white" onClick={() => setShowAiInsightsModal(false)}>Close</Button>
            </ModalFooter>
          </Modal>
          
          {/* Dispute Quick View Modal */}
          {selectedDispute && (
            <DisputeQuickView 
              citation={selectedDispute}
              isOpen={showQuickViewModal}
              toggle={() => setShowQuickViewModal(false)}
              onAccept={handleAcceptDispute}
              onReject={handleRejectDispute}
              onAdjust={handleAdjustDispute}
              onViewFull={(citation) => {
                if (user?.type === 'super') {
                  const recommendation = citation.aiAnalysis ? {
                    action: citation.aiAnalysis.recommendation,
                    confidence: citation.aiAnalysis.validityPercentage,
                    reason: citation.aiAnalysis.reasoning,
                  } : getRecommendedAction(citation);
                  
                  const score = getScoreForEmail(citation.dispute?.email);
                  const aiData = encodeURIComponent(JSON.stringify({
                    action: recommendation.action,
                    confidence: recommendation.confidence,
                    reason: recommendation.reason,
                    trustScore: score
                  }));
                  window.location.href = `/citation/${citation.violation_number || 'unknown'}?aiData=${aiData}`;
                } else {
                  window.location.href = `/citation/${citation.violation_number || 'unknown'}`;
                }
              }}
              users={props.users || []}
              isSuperAdmin={user?.type === 'super'}
              aiRecommendation={selectedDispute.aiAnalysis ? {
                action: selectedDispute.aiAnalysis.recommendation,
                confidence: selectedDispute.aiAnalysis.validityPercentage,
                reason: selectedDispute.aiAnalysis.reasoning,
              } : getRecommendedAction(selectedDispute)}
              trustScore={getScoreForEmail(selectedDispute.dispute?.email)}
              className="quick-view-modal"
            />
          )}
          
          {/* Adjust Balance Modal */}
          {selectedDispute && showAdjustModal && (
            <AdjustBalanceModal 
              isOpen={showAdjustModal}
              toggle={() => setShowAdjustModal(false)}
              citation={selectedDispute}
              onAdjust={(citation, amount, note) => {
                adjustDispute(citation, amount, note);
                setShowAdjustModal(false);
              }}
            />
          )}
          
          {/* Analysis Results Modal */}
          <Modal
            open={showAnalysisResultsModal}
            toggle={() => setShowAnalysisResultsModal(false)}
            size="lg"
            style={{ maxWidth: '800px' }}
          >
            <ModalHeader toggle={() => setShowAnalysisResultsModal(false)}>
              <div className="d-flex align-items-center">
                <FontAwesomeIcon icon={faBrain} className="mr-2" style={{color: '#3498db'}} />
                <div>
                  <div>Historical Dispute Analysis</div>
                  <div style={{fontSize: '12px', color: '#818ea3', fontWeight: 'normal'}}>Patterns found in dispute data</div>
                    </div>
                    </div>
            </ModalHeader>
            <ModalBody className="p-4" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              {!disputePatterns ? (
                <div className="text-center py-4">
                  <ActivityIndicator size="large" />
                  <p className="mt-3 text-muted">Analyzing dispute patterns...</p>
                      </div>
              ) : (
                <>
                  {/* Scam Patterns Section */}
                  <div className="mb-4">
                    <h6 className="mb-3" style={{fontSize: '15px', fontWeight: '600'}}>Common Fraudulent Dispute Patterns</h6>
                    
                    {disputePatterns.scamPatterns && disputePatterns.scamPatterns.length > 0 ? (
                      disputePatterns.scamPatterns.map((pattern, idx) => (
                        <Card key={idx} className="mb-3" style={{borderRadius: '6px', borderColor: '#eaedf3'}}>
                          <CardBody className="p-3">
                            <div className="d-flex justify-content-between align-items-start">
                              <div>
                                <h6 className="font-weight-bold mb-2" style={{fontSize: '15px', color: '#C81712'}}>{pattern.pattern}</h6>
                                <div className="mb-2">
                                  <span style={{
                                    display: 'inline-block',
                                    padding: '2px 6px',
                                    borderRadius: '12px',
                                    backgroundColor: 'rgba(200, 23, 18, 0.1)',
                                    color: '#C81712',
                                    fontSize: '12px',
                                    fontWeight: '500',
                                    marginBottom: '8px'
                                  }}>
                                    Frequency: {typeof pattern.frequency === 'number' ? 
                                      (pattern.frequency > 1 && pattern.frequency <= 100 ? `${pattern.frequency}%` : pattern.frequency) : 
                                      'Unknown'}
                                  </span>
                    </div>
                                
                                <p className="mb-2" style={{fontSize: '14px'}}>
                                  <strong>Key Indicators:</strong>
                                </p>
                                <ul className="pl-3 mb-3">
                                  {pattern.indicators && Array.isArray(pattern.indicators) ? 
                                    pattern.indicators.map((indicator, i) => (
                                      <li key={i} style={{fontSize: '13px', marginBottom: '4px'}}>{indicator}</li>
                                    )) : 
                                    <li style={{fontSize: '13px', marginBottom: '4px', fontStyle: 'italic'}}>No indicators provided</li>
                                  }
                                </ul>
                                
                                {pattern.recommendedResponse && (
                      <div style={{
                                    backgroundColor: 'rgba(33, 170, 115, 0.05)',
                                    borderRadius: '4px',
                                    padding: '10px',
                                    border: '1px solid rgba(33, 170, 115, 0.2)'
                                  }}>
                                    <p className="mb-0" style={{fontSize: '13px'}}>
                                      <strong>Recommended Response:</strong> {pattern.recommendedResponse}
                                    </p>
                      </div>
                    )}
                  </div>
                    </div>
                          </CardBody>
                        </Card>
                      ))
                    ) : (
                      <Card className="mb-3" style={{borderRadius: '6px', borderColor: '#eaedf3'}}>
                        <CardBody className="p-3 text-center">
                          <p className="mb-0 text-muted">No fraudulent patterns identified in the analyzed data.</p>
                        </CardBody>
                      </Card>
                    )}
                  </div>
                  
                  {/* Legitimate Patterns Section */}
                  <div className="mb-4">
                    <h6 className="mb-3" style={{fontSize: '15px', fontWeight: '600'}}>Legitimate Dispute Patterns</h6>
                    
                    {disputePatterns.legitimatePatterns && disputePatterns.legitimatePatterns.length > 0 ? (
                      disputePatterns.legitimatePatterns.map((pattern, idx) => (
                        <Card key={idx} className="mb-3" style={{borderRadius: '6px', borderColor: '#eaedf3'}}>
                          <CardBody className="p-3">
                            <div className="d-flex justify-content-between align-items-start">
                              <div>
                                <h6 className="font-weight-bold mb-2" style={{fontSize: '15px', color: '#21AA73'}}>{pattern.pattern}</h6>
                                <div className="mb-2">
                                  <span style={{
                                    display: 'inline-block',
                                    padding: '2px 6px',
                                    borderRadius: '12px',
                                    backgroundColor: 'rgba(33, 170, 115, 0.1)',
                                    color: '#21AA73',
                                    fontSize: '12px',
                                    fontWeight: '500',
                                    marginBottom: '8px'
                                  }}>
                                    Frequency: {typeof pattern.frequency === 'number' ? 
                                      (pattern.frequency > 1 && pattern.frequency <= 100 ? `${pattern.frequency}%` : pattern.frequency) : 
                                      'Unknown'}
                                  </span>
                    </div>
                                
                                <p className="mb-2" style={{fontSize: '14px'}}>
                                  <strong>Key Indicators:</strong>
                                </p>
                                <ul className="pl-3 mb-0">
                                  {pattern.indicators && Array.isArray(pattern.indicators) ? 
                                    pattern.indicators.map((indicator, i) => (
                                      <li key={i} style={{fontSize: '13px', marginBottom: '4px'}}>{indicator}</li>
                                    )) : 
                                    <li style={{fontSize: '13px', marginBottom: '4px', fontStyle: 'italic'}}>No indicators provided</li>
                                  }
                                </ul>
                    </div>
                      </div>
                          </CardBody>
                        </Card>
                      ))
                    ) : (
                      <Card className="mb-3" style={{borderRadius: '6px', borderColor: '#eaedf3'}}>
                        <CardBody className="p-3 text-center">
                          <p className="mb-0 text-muted">No legitimate patterns identified in the analyzed data.</p>
                        </CardBody>
                      </Card>
                    )}
                </div>
                
              {/* Language Analysis */}
              {disputePatterns.languageAnalysis && (
                <div className="mb-4 row">
                  <div className="col-md-6">
                    <Card>
                      <CardBody>
                        <h6 className="mb-3" style={{fontSize: '15px', fontWeight: '600', color: '#C81712'}}>
                          <FontAwesomeIcon icon={faTimesCircle} className="mr-2" />
                          Fraudulent Language
                        </h6>
                        {disputePatterns.languageAnalysis.fraudulentPhrases && 
                          disputePatterns.languageAnalysis.fraudulentPhrases.length > 0 ? (
                          <ul className="pl-4" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                            {disputePatterns.languageAnalysis.fraudulentPhrases.map((phrase, idx) => (
                              <li key={idx} style={{marginBottom: '8px', fontSize: '13px'}}>{phrase}</li>
                            ))}
                          </ul>
                        ) : (
                          <p className="text-muted text-center">No fraudulent language patterns detected.</p>
                        )}
                      </CardBody>
                    </Card>
                  </div>
              
                  <div className="col-md-6">
                    <Card>
                      <CardBody>
                        <h6 className="mb-3" style={{fontSize: '15px', fontWeight: '600', color: '#21AA73'}}>
                          <FontAwesomeIcon icon={faCheckCircle} className="mr-2" />
                          Legitimate Language
                        </h6>
                        {disputePatterns.languageAnalysis.legitimatePhrases && 
                          disputePatterns.languageAnalysis.legitimatePhrases.length > 0 ? (
                          <ul className="pl-4" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                            {disputePatterns.languageAnalysis.legitimatePhrases.map((phrase, idx) => (
                              <li key={idx} style={{marginBottom: '8px', fontSize: '13px'}}>{phrase}</li>
                            ))}
                          </ul>
                        ) : (
                          <p className="text-muted text-center">No legitimate language patterns detected.</p>
                        )}
                      </CardBody>
                    </Card>
                  </div>
                </div>
              )}
                  
              {/* Insights */}
              <div>
                <h6 className="mb-3" style={{fontSize: '15px', fontWeight: '600'}}>Key Insights</h6>
                <Card>
                  <CardBody>
                    {disputePatterns.insights && disputePatterns.insights.length > 0 ? (
                      <ul className="pl-4 mb-0" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                        {disputePatterns.insights.map((insight, idx) => (
                          <li key={idx} style={{marginBottom: '10px', fontSize: '14px'}}>{insight}</li>
                        ))}
                      </ul>
                    ) : (
                      <p className="text-muted text-center">No additional insights available.</p>
                    )}
                  </CardBody>
                </Card>
              </div>
            </>
          )}
        </ModalBody>
        <ModalFooter>
            <Button theme="white" onClick={() => setShowAnalysisResultsModal(false)}>Close</Button>
            <Button theme="primary" onClick={() => runHistoricalAnalysis()} disabled={analyzing}>
              {analyzing ? 'Analyzing...' : 'Run New Analysis'}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Stats Modal */}
      <Modal
        open={showStatsModal}
        toggle={() => setShowStatsModal(false)}
        size="lg"
      >
        <ModalHeader toggle={() => setShowStatsModal(false)}>
          <div className="d-flex align-items-center">
            <FontAwesomeIcon icon={faChartPie} className="mr-2" style={{color: '#3498db'}} />
            <div>
              <div>Dispute Statistics</div>
                  <div style={{fontSize: '12px', color: '#818ea3', fontWeight: 'normal'}}>Performance metrics and trends</div>
            </div>
          </div>
        </ModalHeader>
        <ModalBody className="p-4">
          <Row>
            {smallStats.map((stats, idx) => (
                  <Col key={idx} {...stats.attrs} className="mb-4">
                <SmallStats
                  id={`small-stats-${idx}`}
                  variation="1"
                  chartData={stats.datasets}
                  chartLabels={stats.chartLabels}
                  label={stats.label}
                  value={stats.value}
                  percentage={stats.percentage}
                  increase={stats.increase}
                  decrease={!stats.increase}
                />
              </Col>
            ))}
          </Row>
          
          <Row className="mt-4">
            <Col md="6">
              <Card className="mb-4">
                <CardHeader className="border-bottom">
                  <h6 className="m-0 font-weight-bold">Resolution Types</h6>
                </CardHeader>
                <CardBody className="p-0">
                  <div style={{ height: '300px', padding: '20px' }}>
                    <div className="text-center mb-5">
                      <div className="d-flex justify-content-center mb-4">
                        <div className="px-4">
                          <div style={{ fontSize: '24px', fontWeight: '700', color: '#21AA73' }}>{metrics.acceptedPercentage}%</div>
                          <div style={{ fontSize: '14px', color: '#818ea3' }}>Accepted</div>
                        </div>
                        <div className="px-4">
                          <div style={{ fontSize: '24px', fontWeight: '700', color: '#C81712' }}>{metrics.rejectedPercentage}%</div>
                          <div style={{ fontSize: '14px', color: '#818ea3' }}>Rejected</div>
                        </div>
                        <div className="px-4">
                          <div style={{ fontSize: '24px', fontWeight: '700', color: '#3498db' }}>{metrics.adjustedPercentage}%</div>
                          <div style={{ fontSize: '14px', color: '#818ea3' }}>Adjusted</div>
                        </div>
                      </div>
                      
                      <div className="d-flex align-items-center mb-3">
                        <div style={{ 
                          height: '20px', 
                          backgroundColor: '#21AA73',
                          borderRadius: '4px 0 0 4px',
                          width: `${metrics.acceptedPercentage}%`
                        }}></div>
                        <div style={{ 
                          height: '20px', 
                          backgroundColor: '#C81712',
                          width: `${metrics.rejectedPercentage}%`
                        }}></div>
                        <div style={{ 
                          height: '20px', 
                          backgroundColor: '#3498db',
                          borderRadius: '0 4px 4px 0',
                          width: `${metrics.adjustedPercentage}%`
                        }}></div>
                      </div>
                      
                      <div className="d-flex justify-content-between">
                        <div style={{ fontSize: '12px', color: '#818ea3' }}>0%</div>
                        <div style={{ fontSize: '12px', color: '#818ea3' }}>100%</div>
                      </div>
                    </div>
                    
                    <div className="mt-4">
                      <h6 className="mb-3 font-weight-bold" style={{ fontSize: '14px' }}>Resolution Time</h6>
                      <div className="d-flex align-items-center">
                        <div style={{ 
                          width: '50px',
                          height: '50px',
                          borderRadius: '50%',
                          backgroundColor: 'rgba(52, 152, 219, 0.1)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '15px'
                        }}>
                          <FontAwesomeIcon icon={faClock} style={{ color: '#3498db', fontSize: '20px' }} />
                        </div>
                        <div>
                          <div style={{ fontSize: '20px', fontWeight: '600' }}>{metrics.avgResolutionTime} hrs</div>
                          <div style={{ fontSize: '13px', color: '#818ea3' }}>Average resolution time</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            
            <Col md="6">
              <Card className="mb-4">
                <CardHeader className="border-bottom">
                  <h6 className="m-0 font-weight-bold">Dispute Volume Trend</h6>
                </CardHeader>
                <CardBody>
                  <div className="text-center py-5">
                    <FontAwesomeIcon icon={faChartLine} style={{ fontSize: '40px', color: '#e9ecef', marginBottom: '15px' }} />
                    <p className="text-muted">Trend visualization will be available when more historical data is collected.</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button theme="white" onClick={() => setShowStatsModal(false)}>Close</Button>
        </ModalFooter>
      </Modal>
      
      {/* Auto Resolution Modal */}
      <Modal
        open={showAutoResolutionModal}
        toggle={() => setShowAutoResolutionModal(false)}
        size="lg"
      >
        <ModalHeader toggle={() => setShowAutoResolutionModal(false)}>
          <div className="d-flex align-items-center">
            <FontAwesomeIcon icon={faRobot} className="mr-2" style={{color: '#21AA73'}} />
            <div>
              <div>AI Auto-Resolution</div>
              <div style={{fontSize: '12px', color: '#818ea3', fontWeight: 'normal'}}>Configure automated dispute handling</div>
            </div>
          </div>
        </ModalHeader>
        <ModalBody className="p-0" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          <Nav tabs className="px-3 pt-3 sticky-top bg-white">
            <NavItem>
              <NavLink
                className={activeAutoResolutionTab === "settings" ? "active" : ""}
                onClick={() => setActiveAutoResolutionTab("settings")}
                style={{cursor: 'pointer'}}
              >
                <FontAwesomeIcon icon={faLightbulb} className="mr-2" />
                Settings
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeAutoResolutionTab === "history" ? "active" : ""}
                onClick={() => setActiveAutoResolutionTab("history")}
                style={{cursor: 'pointer'}}
              >
                <FontAwesomeIcon icon={faCheckCircle} className="mr-2" />
                Resolution History
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeAutoResolutionTab === "logs" ? "active" : ""}
                onClick={() => setActiveAutoResolutionTab("logs")}
                style={{cursor: 'pointer'}}
              >
                <FontAwesomeIcon icon={faFileInvoiceDollar} className="mr-2" />
                AI Logs
              </NavLink>
            </NavItem>
          </Nav>
      
          <div className="p-4">
            {activeAutoResolutionTab === "settings" && (
              <>
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h5 className="mb-1 font-weight-bold">AI Auto-Resolution</h5>
                    <p className="text-muted mb-0" style={{fontSize: '14px'}}>
                      Let AI automatically resolve disputes based on your criteria
                    </p>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="mr-3" style={{fontSize: '14px', color: autoResolutionEnabled ? '#21AA73' : '#818ea3'}}>
                      {autoResolutionEnabled ? 'Enabled' : 'Disabled'}
                    </div>
                    <div className="custom-control custom-switch">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="autoResolutionSwitch"
                        checked={autoResolutionEnabled}
                        onChange={() => setAutoResolutionEnabled(!autoResolutionEnabled)}
                      />
                      <label className="custom-control-label" htmlFor="autoResolutionSwitch"></label>
                    </div>
                  </div>
                </div>
                
                <div className={`mt-4 ${!autoResolutionEnabled ? 'opacity-50' : ''}`}>
                  <Card className="mb-4">
                    <CardHeader className="bg-light">
                      <h6 className="m-0 font-weight-bold">Confidence Thresholds</h6>
                    </CardHeader>
                    <CardBody>
                      <p className="text-muted mb-3">Set the minimum AI confidence required to auto-resolve different types of disputes:</p>
                      
                      <div className="mb-3">
                        <label className="d-flex justify-content-between mb-2">
                          <span style={{fontSize: '14px', fontWeight: '500'}}>Accept Disputes</span>
                          <span style={{fontSize: '14px', color: '#21AA73'}}>90%</span>
                        </label>
                        <input 
                          type="range" 
                          className="custom-range" 
                          min="75" 
                          max="100" 
                          step="1" 
                          defaultValue="90"
                          disabled={!autoResolutionEnabled}
                        />
                        <div className="d-flex justify-content-between mt-1">
                          <small className="text-muted">75%</small>
                          <small className="text-muted">100%</small>
                        </div>
                      </div>
              
                      <div className="mb-3">
                        <label className="d-flex justify-content-between mb-2">
                          <span style={{fontSize: '14px', fontWeight: '500'}}>Reject Disputes</span>
                          <span style={{fontSize: '14px', color: '#C81712'}}>90%</span>
                        </label>
                        <input 
                          type="range" 
                          className="custom-range" 
                          min="75" 
                          max="100" 
                          step="1" 
                          defaultValue="90"
                          disabled={!autoResolutionEnabled}
                        />
                        <div className="d-flex justify-content-between mt-1">
                          <small className="text-muted">75%</small>
                          <small className="text-muted">100%</small>
                        </div>
                      </div>
                      
                      <div>
                        <label className="d-flex justify-content-between mb-2">
                          <span style={{fontSize: '14px', fontWeight: '500'}}>Adjust Disputes</span>
                          <span style={{fontSize: '14px', color: '#3498db'}}>95%</span>
                        </label>
                        <input 
                          type="range" 
                          className="custom-range" 
                          min="75" 
                          max="100" 
                          step="1" 
                          defaultValue="95"
                          disabled={!autoResolutionEnabled}
                        />
                        <div className="d-flex justify-content-between mt-1">
                          <small className="text-muted">75%</small>
                          <small className="text-muted">100%</small>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                  
                  <Card className="mb-4">
                    <CardHeader className="bg-light">
                      <h6 className="m-0 font-weight-bold">Auto-Resolution Limits</h6>
                    </CardHeader>
                    <CardBody>
                      <div className="mb-3">
                        <label htmlFor="maxAmount" className="font-weight-bold mb-2" style={{fontSize: '14px'}}>
                          Maximum Amount
                        </label>
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <span className="input-group-text">$</span>
                          </div>
                          <input 
                            type="number" 
                            className="form-control" 
                            id="maxAmount" 
                            placeholder="Enter maximum amount"
                            defaultValue="100"
                            disabled={!autoResolutionEnabled}
                          />
                        </div>
                        <small className="text-muted">Disputes with amounts higher than this will require manual review</small>
                      </div>
                      
                      <div>
                        <label htmlFor="maxAdjustmentPercent" className="font-weight-bold mb-2" style={{fontSize: '14px'}}>
                          Maximum Adjustment Percentage
                        </label>
                        <div className="input-group">
                          <input 
                            type="number" 
                            className="form-control" 
                            id="maxAdjustmentPercent" 
                            placeholder="Enter maximum adjustment percentage"
                            defaultValue="50"
                            disabled={!autoResolutionEnabled}
                          />
                          <div className="input-group-append">
                            <span className="input-group-text">%</span>
                          </div>
                        </div>
                        <small className="text-muted">AI will not adjust disputes by more than this percentage</small>
                      </div>
                    </CardBody>
                  </Card>
                  
                  <Card className="mb-4">
                    <CardHeader className="bg-light">
                      <h6 className="m-0 font-weight-bold">Excluded Categories</h6>
                    </CardHeader>
                    <CardBody>
                      <p className="text-muted mb-3">Disputes in these categories will always require manual review:</p>
                      
                      <div className="d-flex flex-wrap">
                        <div className="custom-control custom-checkbox mr-4 mb-3">
                          <input 
                            type="checkbox" 
                            className="custom-control-input" 
                            id="excludeHighValue" 
                            defaultChecked 
                            disabled={!autoResolutionEnabled}
                          />
                          <label className="custom-control-label" htmlFor="excludeHighValue">
                            High value disputes (over $100)
                          </label>
                        </div>
                        
                        <div className="custom-control custom-checkbox mr-4 mb-3">
                          <input 
                            type="checkbox" 
                            className="custom-control-input" 
                            id="excludeRepeatDisputers" 
                            defaultChecked
                            disabled={!autoResolutionEnabled}
                          />
                          <label className="custom-control-label" htmlFor="excludeRepeatDisputers">
                            Repeat disputers (&gt;3 disputes)
                          </label>
                        </div>
                        
                        <div className="custom-control custom-checkbox mr-4 mb-3">
                          <input 
                            type="checkbox" 
                            className="custom-control-input" 
                            id="excludeLowTrust" 
                            defaultChecked
                            disabled={!autoResolutionEnabled}
                          />
                          <label className="custom-control-label" htmlFor="excludeLowTrust">
                            Low trust score (&lt;40)
                          </label>
                        </div>
                        
                        <div className="custom-control custom-checkbox mr-4 mb-3">
                          <input 
                            type="checkbox" 
                            className="custom-control-input" 
                            id="excludeHandicap" 
                            defaultChecked
                            disabled={!autoResolutionEnabled}
                          />
                          <label className="custom-control-label" htmlFor="excludeHandicap">
                            Handicap violations
                          </label>
                        </div>
                        
                        <div className="custom-control custom-checkbox mr-4 mb-3">
                          <input 
                            type="checkbox" 
                            className="custom-control-input" 
                            id="excludeFireLane"
                            defaultChecked
                            disabled={!autoResolutionEnabled}
                          />
                          <label className="custom-control-label" htmlFor="excludeFireLane">
                            Fire lane violations
                          </label>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                  
                  <Card className="mb-4">
                    <CardHeader className="bg-light">
                      <h6 className="m-0 font-weight-bold">Email Personas & Client Context</h6>
                    </CardHeader>
                    <CardBody>
                      <p className="text-muted mb-3">Customize AI responses based on client and dispute type:</p>
                      
                      <div className="mb-4">
                        <label className="font-weight-bold mb-2" style={{fontSize: '14px'}}>
                          Email Persona Selection
                        </label>
                        <p className="text-muted mb-3" style={{fontSize: '13px'}}>
                          Choose a persona for the AI to use when responding to customers
                        </p>
                        
                        <Row>
                          <Col md="6" lg="4" className="mb-3">
                            <div 
                              className={`border rounded p-3 h-100 d-flex flex-column position-relative ${!autoResolutionEnabled ? 'opacity-50' : ''}`}
                                style={{
                                cursor: autoResolutionEnabled ? 'pointer' : 'default',
                                backgroundColor: 'rgba(33, 170, 115, 0.05)',
                                borderColor: 'rgba(33, 170, 115, 0.3)'
                              }}
                            >
                              <div className="position-absolute" style={{top: '10px', right: '10px'}}>
                                <FontAwesomeIcon icon={faCheck} className="text-success" style={{color: '#21AA73'}} />
                              </div>
                              <div className="text-center mb-3">
                                <div 
                                  style={{
                                    width: '60px',
                                    height: '60px',
                                  borderRadius: '50%',
                                    backgroundColor: '#f0f2f5',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                    margin: '0 auto'
                                }}
                              >
                                  <FontAwesomeIcon icon={faUsers} style={{color: '#6c757d', fontSize: '24px'}} />
                              </div>
                                </div>
                              <h6 className="text-center mb-1">Dispute Team</h6>
                              <p className="text-center text-muted mb-0" style={{fontSize: '13px'}}>Generic</p>
                              </div>
                          </Col>
                          
                          <Col md="6" lg="4" className="mb-3">
                            <div 
                              className={`border rounded p-3 h-100 d-flex flex-column ${!autoResolutionEnabled ? 'opacity-50' : ''}`}
                                style={{
                                cursor: autoResolutionEnabled ? 'pointer' : 'default'
                              }}
                            >
                              <div className="text-center mb-3">
                                <div 
                                  style={{
                                    width: '60px',
                                    height: '60px',
                                    borderRadius: '50%',
                                    backgroundColor: '#f0f2f5',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    margin: '0 auto'
                                  }}
                                >
                                  <FontAwesomeIcon icon={faUserTie} style={{color: '#21AA73', fontSize: '24px'}} />
                                </div>
                              </div>
                              <h6 className="text-center mb-1">Michael Johnson</h6>
                              <p className="text-center text-muted mb-0" style={{fontSize: '13px'}}>Support Manager</p>
                            </div>
                          </Col>
                          
                          <Col md="6" lg="4" className="mb-3">
                            <div 
                              className={`border rounded p-3 h-100 d-flex flex-column ${!autoResolutionEnabled ? 'opacity-50' : ''}`}
                              style={{
                                cursor: autoResolutionEnabled ? 'pointer' : 'default'
                              }}
                            >
                              <div className="text-center mb-3">
                                <div 
                                  style={{
                                    width: '60px',
                                    height: '60px',
                                  borderRadius: '50%',
                                    backgroundColor: '#f0f2f5',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                    margin: '0 auto'
                              }}
                            >
                                  <FontAwesomeIcon icon={faUserCircle} style={{color: '#F9A43F', fontSize: '24px'}} />
                            </div>
                              </div>
                              <h6 className="text-center mb-1">Sarah Williams</h6>
                              <p className="text-center text-muted mb-0" style={{fontSize: '13px'}}>Customer Relations</p>
                            </div>
                          </Col>
                          
                          <Col md="6" lg="4" className="mb-3">
                            <div 
                              className={`border rounded p-3 h-100 d-flex flex-column ${!autoResolutionEnabled ? 'opacity-50' : ''}`}
                              style={{
                                cursor: autoResolutionEnabled ? 'pointer' : 'default'
                              }}
                            >
                              <div className="text-center mb-3">
                                <div 
                                  style={{
                                    width: '60px',
                                    height: '60px',
                                    borderRadius: '50%',
                                    backgroundColor: '#f0f2f5',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    margin: '0 auto'
                                  }}
                                >
                                  <FontAwesomeIcon icon={faUserCircle} style={{color: '#21AA73', fontSize: '24px'}} />
                            </div>
                            </div>
                              <h6 className="text-center mb-1">David Thompson</h6>
                              <p className="text-center text-muted mb-0" style={{fontSize: '13px'}}>Dispute Manager</p>
                            </div>
                          </Col>
                          
                          <Col md="6" lg="4" className="mb-3">
                            <div 
                              className={`border rounded p-3 h-100 d-flex flex-column ${!autoResolutionEnabled ? 'opacity-50' : ''}`}
                              style={{
                                cursor: autoResolutionEnabled ? 'pointer' : 'default'
                              }}
                            >
                              <div className="text-center mb-3">
                                <div 
                                  style={{
                                    width: '60px',
                                    height: '60px',
                                    borderRadius: '50%',
                                    backgroundColor: '#f0f2f5',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    margin: '0 auto'
                                  }}
                                >
                                  <FontAwesomeIcon icon={faUserCircle} style={{color: '#8e44ad', fontSize: '24px'}} />
                                </div>
                              </div>
                              <h6 className="text-center mb-1">Jennifer Parker</h6>
                              <p className="text-center text-muted mb-0" style={{fontSize: '13px'}}>Customer Advocate</p>
                            </div>
                          </Col>
                        </Row>
                      </div>
            
                      <div className="mb-4">
                        <label className="font-weight-bold mb-2" style={{fontSize: '14px'}}>
                          Email Tone Customization
                        </label>
                        <p className="text-muted mb-2" style={{fontSize: '13px'}}>
                          Paste example emails to teach the AI your preferred tone and writing style
                        </p>
                        
                        <div className="position-relative">
                          <FormTextarea
                            style={{minHeight: '120px'}}
                            disabled={!autoResolutionEnabled}
                            placeholder="Paste sample email responses here. The AI will learn your tone, phrasing and style."
                          />
                          <Button 
                            theme="light" 
                            size="sm" 
                            style={{
                              position: 'absolute',
                              top: '10px',
                              right: '10px',
                              padding: '3px 8px'
                            }}
                            disabled={!autoResolutionEnabled}
                          >
                            Reset
                          </Button>
                        </div>
                        
                        <div className={`mt-3 p-3 border rounded ${!autoResolutionEnabled ? 'opacity-50' : ''}`} style={{backgroundColor: '#f8f9fa'}}>
                          <div className="d-flex align-items-start">
                            <FontAwesomeIcon icon={faLightbulb} className="mr-2 mt-1" style={{color: '#F9A43F'}} />
                            <div>
                              <div className="font-weight-bold mb-1" style={{fontSize: '14px'}}>Tips for best results</div>
                              <ul className="pl-3 mb-0">
                                <li style={{fontSize: '13px', marginBottom: '5px'}}>Include examples for both approvals and rejections</li>
                                <li style={{fontSize: '13px', marginBottom: '5px'}}>Provide 2-3 different sample emails for more variety</li>
                                <li style={{fontSize: '13px'}}>Include your typical greeting and sign-off style</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
        
                      <div className="mb-4">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <label className="font-weight-bold mb-0" style={{fontSize: '14px'}}>
                            Location-specific Instructions
                          </label>
                          <Button 
                            size="sm" 
                            theme="light"
                            disabled={!autoResolutionEnabled}
                          >
                            Reset
                          </Button>
                        </div>
                        <p className="text-muted mb-3" style={{fontSize: '13px'}}>
                          Provide specific handling instructions for disputes based on location or circumstances
                        </p>
                        
                        <div className="border rounded p-4">
                          <div className="mb-3">
                            <label htmlFor="ruleTitle" style={{fontSize: '14px'}}>Title (e.g., "Downtown Area" or "Short Violations")</label>
                            <input 
                              type="text" 
                              className="form-control" 
                              id="ruleTitle" 
                              placeholder="Enter a title for this rule"
                              disabled={!autoResolutionEnabled}
                              />
                          </div>
                          
                          <div className="mb-3">
                            <label htmlFor="aiInstruction" style={{fontSize: '14px'}}>Instruction for AI</label>
                            <FormTextarea
                              id="aiInstruction"
                              style={{minHeight: '100px'}}
                              disabled={!autoResolutionEnabled}
                              placeholder="E.g., 'If signage is mentioned as unclear in downtown area, offer 50% discount' or 'Approve disputes if under 5 mins elapsed from valid ticket'"
                            />
                          </div>
            
                          <div className="text-right">
                            <Button 
                              theme="light" 
                              size="sm" 
                              disabled={!autoResolutionEnabled}
                            >
                              Add Context
                            </Button>
                          </div>
                        </div>
                      </div>
                      
                      <div className="mb-4">
                        <label className="font-weight-bold mb-2" style={{fontSize: '14px'}}>
                          Client-Specific Context
                        </label>
                        <div className="list-group">
                          {clientsLoading ? (
                            <div className="text-center py-3">
                              <ActivityIndicator size="small" />
                              <p className="mt-2 mb-0 text-muted">Loading clients...</p>
                            </div>
                          ) : localClients && localClients.length > 0 ? localClients.map(client => (
                            <div key={client.id} className="list-group-item p-3">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <strong>{client.name || "Unnamed Client"}</strong>
                                <Button 
                                  size="sm" 
                                  theme="light" 
                                  disabled={!autoResolutionEnabled}
                                >
                                  <FontAwesomeIcon icon={faEdit} className="mr-1" /> Edit
                                </Button>
                              </div>
                              <div style={{fontSize: '13px'}}>
                                <div className="mb-1"><strong>Special Instructions:</strong> {client.aiContext || "No custom instructions set"}</div>
                                <div><strong>Reference Policy:</strong> {client.policyReference || "Standard policy"}</div>
                              </div>
                            </div>
                          )) : (
                            <div className="text-center py-3 text-muted">
                              No clients available
                            </div>
                          )}
                          </div>
                          <Button
                            size="sm"
                            theme="primary" 
                            outline 
                            className="mt-2"
                            disabled={!autoResolutionEnabled}
                          >
                            <FontAwesomeIcon icon={faPlus} className="mr-1" />
                            Add Client Context
                          </Button>
                        </div>
                      
                      <div>
                        <label className="font-weight-bold mb-2" style={{fontSize: '14px'}}>
                          Custom Email Templates
                        </label>
                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <thead className="bg-light">
                              <tr>
                                <th style={{fontSize: '13px'}}>Action Type</th>
                                <th style={{fontSize: '13px'}}>Template</th>
                                <th style={{fontSize: '13px', width: '80px'}}>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td><span className="badge badge-success">Accept</span></td>
                                <td style={{fontSize: '13px'}}>Default acceptance template</td>
                                <td>
                                  <Button 
                                    size="sm" 
                                    theme="light"
                                    disabled={!autoResolutionEnabled}
                                    style={{padding: '3px 8px'}}
                                  >
                                    <FontAwesomeIcon icon={faEdit} />
                                  </Button>
                                </td>
                              </tr>
                              <tr>
                                <td><span className="badge badge-danger">Reject</span></td>
                                <td style={{fontSize: '13px'}}>Default rejection template</td>
                                <td>
                                  <Button 
                                    size="sm" 
                                    theme="light" 
                                    disabled={!autoResolutionEnabled}
                                    style={{padding: '3px 8px'}}
                                  >
                                    <FontAwesomeIcon icon={faEdit} />
                                  </Button>
                                </td>
                              </tr>
                              <tr>
                                <td><span className="badge badge-info">Adjust</span></td>
                                <td style={{fontSize: '13px'}}>Default adjustment template</td>
                                <td>
                                  <Button 
                                    size="sm" 
                                    theme="light"
                                    disabled={!autoResolutionEnabled}
                                    style={{padding: '3px 8px'}}
                                  >
                                    <FontAwesomeIcon icon={faEdit} />
                                  </Button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                      </div>
                        <Button 
                          size="sm" 
                          theme="primary" 
                          outline 
                          className="mt-2"
                          disabled={!autoResolutionEnabled}
                        >
                          <FontAwesomeIcon icon={faPlus} className="mr-1" />
                          Add Custom Template
                        </Button>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              </>
            )}
            
            {activeAutoResolutionTab === "history" && (
              <>
                <h5 className="mb-3 font-weight-bold">Auto-Resolution History</h5>
                <div className="text-center py-5">
                  <FontAwesomeIcon icon={faRobot} style={{ fontSize: '40px', color: '#e9ecef', marginBottom: '15px' }} />
                  <p className="text-muted">No auto-resolved disputes yet. Enable auto-resolution to get started.</p>
                </div>
              </>
            )}
            
            {activeAutoResolutionTab === "logs" && (
              <>
                <h5 className="mb-3 font-weight-bold">AI Processing Logs</h5>
                <div className="text-center py-5">
                  <FontAwesomeIcon icon={faFileInvoiceDollar} style={{ fontSize: '40px', color: '#e9ecef', marginBottom: '15px' }} />
                  <p className="text-muted">No AI processing logs available yet. Enable auto-resolution to start logging AI decisions.</p>
                </div>
              </>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button theme="white" onClick={() => setShowAutoResolutionModal(false)}>Cancel</Button>
          <Button 
            theme="success" 
            onClick={() => {
              setShowAutoResolutionModal(false);
              // In a real implementation, save settings to the backend
            }}
          >
            Save Settings
          </Button>
        </ModalFooter>
      </Modal>
      
      {/* Client Selector Modal for Analysis */}
      <Modal
        open={showClientSelectorModal}
        toggle={() => setShowClientSelectorModal(false)}
        size="md"
      >
        <ModalHeader toggle={() => setShowClientSelectorModal(false)}>
          <div className="d-flex align-items-center">
            <FontAwesomeIcon icon={faBrain} className="mr-2" style={{color: '#3498db'}} />
            <div>
              <div>Select Client for Analysis</div>
              <div style={{fontSize: '12px', color: '#818ea3', fontWeight: 'normal'}}>
                Choose which client's dispute data to analyze
              </div>
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          {clientsLoading ? (
            <div className="text-center py-4">
              <ActivityIndicator size="small" />
              <p className="mt-3 mb-0">Loading clients data...</p>
            </div>
          ) : (
            <Form>
              <FormGroup>
                <label htmlFor="clientSelect" className="mb-2">Client</label>
                {user && user.type !== 'super' && user.client ? (
                  // For client users, just show their client and disable the selector
                  <FormSelect
                    id="clientSelect"
                    value={user.client}
                    disabled={true}
                  >
                    {localClients && localClients.length > 0 ? 
                      localClients
                        .filter(client => client.id === user.client)
                        .map((client) => (
                          <option key={client.id} value={client.id}>
                            {client.name || "Your Client"}
                          </option>
                        )) : 
                      <option value={user.client}>Your Client</option>
                    }
                  </FormSelect>
                ) : (
                  // For super users, show all clients
                  <FormSelect
                    id="clientSelect"
                    onChange={(e) => setSelectedClientForAnalysis(e.target.value === "all" ? null : e.target.value)}
                    value={selectedClientForAnalysis || "all"}
                  >
                    <option value="all">All Clients (Global Analysis)</option>
                    {localClients && localClients.length > 0 ? (
                      localClients.map((client) => (
                        <option key={client.id} value={client.id}>
                          {client.name || "Unnamed Client"}
                        </option>
                      ))
                    ) : (
                      <option disabled>No clients available</option>
                    )}
                  </FormSelect>
                )}
                <p className="text-muted mt-2" style={{fontSize: "0.85rem"}}>
                  {user && user.type !== 'super' && user.client ? 
                    "The analysis will be performed on your client's dispute patterns." :
                    "Analyzing a specific client will focus only on their dispute patterns. Analyzing all clients will provide global patterns across the entire system."
                  }
                </p>
              </FormGroup>
              <FormGroup>
                <p style={{color: '#818ea3', fontSize: "0.85rem"}}>
                  <FontAwesomeIcon icon={faInfoCircle} className="mr-1" />
                  {' '}
                  {user && user.type !== 'super' && user.client ?
                    "Only disputes from your client will be analyzed." :
                    selectedClientForAnalysis ? 
                      "Only disputes from the selected client will be analyzed." :
                      "Disputes from all clients will be analyzed to find global patterns."
                  }
                </p>
              </FormGroup>
            </Form>
          )}
        </ModalBody>
        <ModalFooter>
          <Button theme="white" onClick={() => setShowClientSelectorModal(false)}>
            Cancel
          </Button>
          <Button 
            theme="primary" 
            onClick={runHistoricalAnalysisForClient}
            disabled={analyzing || clientsLoading}
          >
            {analyzing ? 'Analyzing...' : 'Run Analysis'}
          </Button>
        </ModalFooter>
      </Modal>
      
      {/* Add CSS for modal stacking */}
      <style>
        {`
          /* Ensure modals appear in the correct stacking order */
          .modal-backdrop {
            z-index: 1040 !important;
          }
          .modal.show {
            z-index: 1050 !important;
          }
          
          /* Secondary modal (quick view) should appear above primary modals */
          .modal.quick-view-modal {
            z-index: 1060 !important;
          }
          .modal.quick-view-modal + .modal-backdrop {
            z-index: 1055 !important;
          }
        `}
      </style>

      {/* AI Analysis Modal */}
      <Modal open={showAnalysisModal} toggle={() => setShowAnalysisModal(!showAnalysisModal)} size="lg">
        <ModalHeader toggle={() => setShowAnalysisModal(!showAnalysisModal)}>
          <FontAwesomeIcon icon={faBrain} className="mr-2" style={{ color: "#6772e5" }} />
          AI Dispute Analysis - Citation #{selectedForAnalysis?.violation_number}
        </ModalHeader>
        <ModalBody>
          {selectedForAnalysis && selectedForAnalysis.dispute && (
            <DisputeAnalysisContainer
              citation={selectedForAnalysis}
              dispute={selectedForAnalysis.dispute}
              locationRules={selectedForAnalysis?.location && props.locations ? 
                props.locations.find(loc => loc.id === selectedForAnalysis.location)?.rules : ''}
              onQuickView={(citation) => {
                setSelectedDispute(citation);
                setShowQuickViewModal(true);
              }}
            />
          )}
        </ModalBody>
        <ModalFooter>
          <Button theme="light" onClick={() => setShowAnalysisModal(!showAnalysisModal)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
        </>
      )}
    </Container>
  );
};

export default DisputeCenter; 